const TestData: any = {
    fields: [
        {
            fieldType: 'Text',
            format: '',
            description: 'Contains only text',
        },
        {
            fieldType: 'Number',
            format: '#,####',
            description: 'Contains only whole numbers',
        },
        {
            fieldType: 'Currency',
            format: '$ #,###.##',
            description:
                'Contains currency amounts as a deminal, stored with 4 decimal precision and currency identifier',
        },
        {
            fieldType: 'Decimal',
            format: '#,###.##',
            description:
                'Contains a decimal number stored with 6 digits of precision and displayed with 1 or 2',
        },
        {
            fieldType: 'Float',
            format: '#,###.######',
            description:
                'Contains a decimal number stored with 10 digits of precision and displayed with 4 or 6',
        },
        {
            fieldType: 'Year',
            format: '####',
            description: '4 Digit year that accepts 0000 as an option.',
        },
        {
            fieldType: 'Date',
            format: 'yyyy-mm-dd',
            description: 'A date stored with the originating timezone',
        },
        {
            fieldType: 'DateTime',
            format: 'yyyy-mm-dd HH:MM:SS aaa',
            description: 'A date and time stored with the originating timezone',
        },
        {
            fieldType: 'Time',
            format: 'HH:MM:SS aaa',
            description: 'A time stored as hh:mm:ss',
        },
        {
            fieldType: 'Phone',
            format: '###-###-####',
            description: 'A phone number text field localized by region',
        },
        {
            fieldType: 'Address',
            format: '',
            description:
                'An address field localized to contain street, unit, city, state, zipcode and other information required for geolocation.',
        },
        {
            fieldType: 'ParticipantId',
            format: '',
            description: 'A 10 digit number in the format ###-###-####',
        },
        {
            fieldType: 'MeasurePhysical',
            format: '#.## m',
            description:
                'A physical measurement stored in metric meters, may be entered as local units',
        },
        {
            fieldType: 'MeasureWeight',
            format: '#.## Kg',
            description:
                'A measurement of weight stored in metric kg, may be entered as local units.',
        },
        {
            fieldType: 'MeasureLiquid',
            format: '#.## fl oz',
            description: 'A linquid measurements stored in fl oz, may be entered as local units',
        },
        {
            fieldType: 'MeasureMedication',
            format: '',
            description:
                'A measurement for medication stored in metric grams, may be entered in g, mg, mcg',
        },
        {
            fieldType: 'Lookup',
            format: '',
            description: 'A drop down or field with known lookup values and coded for localization',
        },
        {
            fieldType: 'Boolean',
            format: '[Yes, No]',
            description: 'A yes or no field with Yes / No text',
        },
        {
            fieldType: 'Switch',
            format: '[On, Off]',
            description: 'An on/off field with no additional text.',
        },
        {
            fieldType: 'GoToRoute',
            format: '',
            description: 'A group of multiple items that can contain one or more selected values.',
        },
        {
            fieldType: 'Calculation',
            format: '',
            description: 'A value that is calcuated at runtime based on the value in other fields.',
        },
        {
            fieldType: 'Foreign Key',
            format: '',
            description: 'A reference to a value within another data dictionary',
        },
        {
            fieldType: 'ID',
            format: '',
            description: 'Unique assign identifier automatically created by the EDC',
        },
        {
            fieldType: 'URL',
            format: '',
            description: 'Any web url',
        },
        {
            fieldType: 'Email',
            format: '',
            description: 'A valid email',
        },
        {
            fieldType: 'Password',
            format: '',
            description: 'Encrypted string',
        },
        {
            fieldType: 'Scale',
            format: '',
            description: 'A slider control that defines values for entering a number',
        },
        {
            fieldType: 'Percent',
            format: '#,###.## %',
            description: 'A decimal number stored where 0 = 0% and 1.0 = 100%',
        },
        {
            fieldType: 'DecimalThousandPerMicroLiter',
            format: '#.### K/ul',
            description: 'Measurement of lab Data in K/uL',
        },
        {
            fieldType: 'DecimalMillionPerMicroLiter',
            format: '#.### M/uL',
            description: 'Measurement of lab Data in M/uL',
        },
        {
            fieldType: 'DecimalPerDeciLiter',
            format: '#.### g/dL',
            description: 'Measurement of lab Data in g/dL',
        },
        {
            fieldType: 'DecimalOneCubicMicroMeter',
            format: '#.### fL',
            description: 'Measurement of lab Data in fL',
        },
        {
            fieldType: 'DecimalKCellsPerMicroLiter',
            format: '#.### Cells / uL',
            description: 'Measurement of lab Data in number of 1000 cells / uL',
        },
        {
            fieldType: 'DecimalMCellsPerMicroLiter',
            format: '#.### Million Cells /uL',
            description: 'Measurement of lab Data in number of 1,000,000 cells / uL',
        },
        {
            fieldType: 'DecimalPicograms',
            format: '#.### pg',
            description: 'Measurement of lab Data in pg.  One pg = 10 -12 grams (pg)',
        },
        {
            fieldType: 'DecimalMillimolesPerLiter',
            format: '#.### mmol/L',
            description:
                'Measurement of lab Data in millimole which is one-thousandth of a mole(mmol/L)',
        },
        {
            fieldType: 'DecimalMilligramsPerDeciliter',
            format: '#.### mg/dL',
            description: 'Measurement of lab Data in milligrams (mg) per deciliter (dL)',
        },
        {
            fieldType: 'DecimalInternationalUnitsPerLiter',
            format: '#.### IU/L',
            description: 'Measurement of lab Data in International units per liter (IU/L)',
        },
        {
            fieldType: 'DecimalGramsPerLiter',
            format: '#.### g/L',
            description: 'Measurement of lab Data in Grams per liter (g/L)',
        },
        {
            fieldType: 'DecimalNanogramsPerMilliliter',
            format: '#.### ng/mL',
            description: 'Measurement of lab Data in Nanograms per milliliter (ng/ML)',
        },
        {
            fieldType: 'DecimalMilligramsPerLiter',
            format: '#.### mg/L',
            description: 'Measurement of lab Data in milligrams per liter (mg/L)',
        },
        {
            fieldType: 'DecimalPicogramsPerMilliliter',
            format: '#.### pg/mL',
            description: 'Measurement of lab Data in Picograms per milliliter (pg/mL)',
        },
        {
            fieldType: 'DecimalMicrogramsPerMilliliter',
            format: '#.### µg/mL',
            description: 'Measurement of lab Data in Micrograms per milliliter (µg/mL)',
        },
        {
            fieldType: 'DecimalMicromolar',
            format: '#.### µM',
            description: 'Measurement of lab Data in Micromolar (µM)',
        },
        {
            fieldType: 'DecimalGramsPerDeciliter',
            format: '#.### g/dL',
            description: 'Measurement of lab Data in Grams per deciliter (g/dL)',
        },
        {
            fieldType: 'DecimalGeometricMeanTiter',
            format: '#.### GMT',
            description: 'Measurement of lab Data in Geometric Mean Titer (GMT)',
        },
        {
            fieldType: 'DecimalMMHour',
            format: '#.### mm/hour',
            description: 'Measurement of lab Data in mm/hh',
        },
        {
            fieldType: 'DecimalMicroLiter',
            format: '#.### µL',
            description: 'Measurement of lab Data in Microliter (µL)',
        },
        {
            fieldType: 'DecimalMillimetersMinuteMeterSq',
            format: '#.### ml/min/m2',
            description: 'Measurement of lab Data in Millimeters per minute per meter square',
        },
        {
            fieldType: '2Logdilution',
            format: '#.### 2log',
            description: 'Measurement of lab Data in 2log dilution',
        },
        {
            fieldType: 'DecimalUnitPerLiter',
            format: '#.## U/L',
            description: 'Measurement of lab Data in Units per liter (U/L)',
        },
    ],
    validations: [
        {
            name: 'None',
            description: 'No validation on the field (defualt)',
            option: '',
            column: '',
        },
        {
            name: 'NotEmpty',
            description: 'Must contain a value',
            option: '',
            column: '',
        },
        {
            name: 'GreaterThan',
            description: 'The value must be greater than some value',
            option: 'Target Value',
            column: '',
        },
        {
            name: 'GreaterThanEqual',
            description: 'The value must be greater than some value or equal to it',
            option: 'Target Value',
            column: '',
        },
        {
            name: 'LessThan',
            description: 'The value must be less than a target value',
            option: 'Target Value',
            column: '',
        },
        {
            name: 'LessThanEqual',
            description: 'The value must be less than or equal to the target value',
            option: 'Target Value',
            column: '',
        },
        {
            name: 'Equal To',
            description: 'The value must be equal to another value',
            option: 'Target Value',
            column: '',
        },
        {
            name: 'GreaterThan',
            description: 'The value must be greater than some value',
            option: 'Target Value',
            column: '',
        },
        {
            name: 'NotEqual',
            description: 'The value must not be the same as the target value',
            option: 'Target Value',
            column: '',
        },
        {
            name: 'PatternMatch',
            description: 'The value must match a given regex pattern',
            option: 'Target Value',
            column: '',
        },
        {
            name: 'NotPatternMatch',
            description: 'The value must not match a given regex pattern',
            option: 'Target Value',
            column: '',
        },
        {
            name: 'Range',
            description: 'The value must be within the range include the minimum and maxium values',
            option: 'Target Min',
            column: 'Target Max',
        },
        {
            name: 'Calculation',
            description: '',
            option: 'Automatic Calculation',
            column: '',
        },
    ],
    lookup: {
        Gender: [
            {
                code: 'M',
                custom_code: 'MALE',
                english: 'Male',
                text_en: 'Male',
            },
            {
                code: 'F',
                custom_code: 'FEMALE',
                english: 'Female',
                text_en: 'Female',
            },
            {
                code: 'N',
                custom_code: 'NOT SPECIFIED',
                english: 'Nonspecified',
                text_en: 'Nonspecified',
            },
            {
                code: 'O',
                custom_code: 'OTHER',
                english: 'Other',
                text_en: 'Other',
            },
        ],
        Sex: [
            {
                code: 'M',
                custom_code: 'MALE',
                english: 'Male',
            },
            {
                code: 'F',
                custom_code: 'FEMALE',
                english: 'Female',
            },
        ],
        Status: [
            {
                code: 'C',
                custom_code: '',
                english: 'Candidate',
            },
            {
                code: 'A',
                custom_code: '',
                english: 'Approved',
            },
            {
                code: 'R',
                custom_code: '',
                english: 'Randomized',
            },
            {
                code: 'E',
                custom_code: '',
                english: 'Enrolled',
            },
            {
                code: 'S',
                custom_code: '',
                english: 'Screenfailed',
            },
            {
                code: 'W',
                custom_code: '',
                english: 'Withdrawn',
            },
        ],
        Phase: [
            {
                code: '1',
                custom_code: '',
                english: 'Pre-Trial',
            },
            {
                code: '2',
                custom_code: '',
                english: 'Windup',
            },
            {
                code: '3',
                custom_code: '',
                english: 'Study Period',
            },
            {
                code: '4',
                custom_code: '',
                english: 'Wind Down',
            },
            {
                code: '5',
                custom_code: '',
                english: 'Post-Trial',
            },
        ],
        Task_Status: [
            {
                code: 'P',
                custom_code: '',
                english: 'Pending',
            },
            {
                code: 'E',
                custom_code: '',
                english: 'Expired',
            },
            {
                code: 'F',
                custom_code: '',
                english: 'Forced Closed',
            },
            {
                code: 'X',
                custom_code: '',
                english: 'Cancelled',
            },
            {
                code: 'C',
                custom_code: '',
                english: 'Completed',
            },
        ],
        Rti_Confirmed: [
            {
                code: 'Yes',
                custom_code: '',
                english: 'Yes (There Has Been a Recent RTI)',
            },
            {
                code: 'No',
                custom_code: '',
                english: 'No',
            },
            {
                code: 'Unknown',
                custom_code: '',
                english: 'Unknown or Unsure',
            },
        ],
        OptionalBoolean: [
            {
                code: 'Yes',
                custom_code: '',
                english: 'Yes',
            },
            {
                code: 'No',
                custom_code: '',
                english: 'No',
            },
            {
                code: 'Unknown',
                custom_code: '',
                english: 'Unknown',
            },
        ],
        YesNoBoolean: [
            {
                code: 'Yes',
                custom_code: '',
                english: 'Yes',
            },
            {
                code: 'No',
                custom_code: '',
                english: 'No',
            },
        ],
        document_status: [
            {
                code: '1',
                custom_code: '',
                english: 'Complete',
            },
            {
                code: '2',
                custom_code: '',
                english: 'Incomplete',
            },
        ],
        Race: [
            {
                code: '1',
                custom_code: '',
                english: 'White',
            },
            {
                code: '2',
                custom_code: '',
                english: 'Black or African American',
            },
            {
                code: '3',
                custom_code: '',
                english: 'Asian',
            },
            {
                code: '4',
                custom_code: '',
                english: 'Native American or Alaska Native',
            },
            {
                code: '5',
                custom_code: '',
                english: 'Native Hawaiian or Pacific Islander',
            },
            {
                code: '6',
                custom_code: '',
                english: 'Multi-Racial',
            },
            {
                code: '7',
                custom_code: '',
                english: 'Unknown or Not Reported',
            },
            {
                code: '8',
                custom_code: '',
                english: 'Other',
            },
        ],
        Ethnicity: [
            {
                code: '1',
                custom_code: '',
                english: 'Hispanic or Latino',
            },
            {
                code: '2',
                custom_code: '',
                english: 'Not Hispanic or Latino',
            },
        ],
        Smoking_status: [
            {
                code: '1',
                custom_code: '',
                english: 'Current Smoker',
            },
            {
                code: '2',
                custom_code: '',
                english: 'Ex-Smoker',
            },
            {
                code: '3',
                custom_code: '',
                english: 'Never Smoked',
            },
        ],
        Smoking_type: [
            {
                code: '1',
                custom_code: '',
                english: 'Tobacco',
            },
            {
                code: '2',
                custom_code: '',
                english: 'Cigarette',
            },
            {
                code: '3',
                custom_code: '',
                english: 'Cigar',
            },
            {
                code: '4',
                custom_code: '',
                english: 'Other',
            },
        ],
        tobacco_frequency: [
            {
                code: '1',
                custom_code: '',
                english: 'Less Than Daily',
            },
            {
                code: '2',
                custom_code: '',
                english: 'On a Daily Basis',
            },
        ],
        tobacco_quantity: [
            {
                code: '1',
                custom_code: '',
                english: 'Less Than 1 Pack a Day',
            },
            {
                code: '2',
                custom_code: '',
                english: 'One Pack or More a Day',
            },
        ],
        dose_form: [
            {
                code: '1',
                custom_code: '',
                english: 'Capsule',
            },
            {
                code: '2',
                custom_code: '',
                english: 'Tablet',
            },
            {
                code: '3',
                custom_code: '',
                english: 'Cream',
            },
            {
                code: '4',
                custom_code: '',
                english: 'Lotion',
            },
            {
                code: '5',
                custom_code: '',
                english: 'Liquid',
            },
            {
                code: '6',
                custom_code: '',
                english: 'Powder',
            },
            {
                code: '7',
                custom_code: '',
                english: 'Aerosol',
            },
            {
                code: '8',
                custom_code: '',
                english: 'Other',
            },
        ],
        dose_route: [
            {
                code: '1',
                custom_code: '',
                english: 'Oral',
            },
            {
                code: '2',
                custom_code: '',
                english: 'Topical',
            },
            {
                code: '3',
                custom_code: '',
                english: 'Parenteral',
            },
            {
                code: '4',
                custom_code: '',
                english: 'Inhalation',
            },
            {
                code: '5',
                custom_code: '',
                english: 'Sub-lingual',
            },
            {
                code: '6',
                custom_code: '',
                english: 'Other',
            },
        ],
        RTI_complications: [
            {
                code: '1',
                custom_code: '',
                english: 'ER Visit',
            },
            {
                code: '2',
                custom_code: '',
                english: 'Hospitalization',
            },
            {
                code: '3',
                custom_code: '',
                english: 'Death',
            },
            {
                code: '4',
                custom_code: '',
                english: 'Other',
            },
        ],
        Day: [
            {
                code: '1',
                custom_code: '',
                english: '1',
            },
            {
                code: '2',
                custom_code: '',
                english: '2',
            },
            {
                code: '3',
                custom_code: '',
                english: '3',
            },
            {
                code: '4',
                custom_code: '',
                english: '4',
            },
            {
                code: '5',
                custom_code: '',
                english: '5',
            },
            {
                code: '6',
                custom_code: '',
                english: '6',
            },
            {
                code: '7',
                custom_code: '',
                english: '7',
            },
            {
                code: '8',
                custom_code: '',
                english: '8',
            },
            {
                code: '9',
                custom_code: '',
                english: '9',
            },
            {
                code: '10',
                custom_code: '',
                english: '10',
            },
            {
                code: '11',
                custom_code: '',
                english: '11',
            },
            {
                code: '12',
                custom_code: '',
                english: '12',
            },
            {
                code: '13',
                custom_code: '',
                english: '13',
            },
            {
                code: '14',
                custom_code: '',
                english: '14',
            },
            {
                code: '15',
                custom_code: '',
                english: '15',
            },
            {
                code: '16',
                custom_code: '',
                english: '16',
            },
            {
                code: '17',
                custom_code: '',
                english: '17',
            },
            {
                code: '18',
                custom_code: '',
                english: '18',
            },
            {
                code: '19',
                custom_code: '',
                english: '19',
            },
            {
                code: '20',
                custom_code: '',
                english: '20',
            },
            {
                code: '21',
                custom_code: '',
                english: '21',
            },
            {
                code: '22',
                custom_code: '',
                english: '22',
            },
            {
                code: '23',
                custom_code: '',
                english: '23',
            },
            {
                code: '24',
                custom_code: '',
                english: '24',
            },
            {
                code: '25',
                custom_code: '',
                english: '25',
            },
            {
                code: '26',
                custom_code: '',
                english: '26',
            },
            {
                code: '27',
                custom_code: '',
                english: '27',
            },
            {
                code: '28',
                custom_code: '',
                english: '28',
            },
            {
                code: '29',
                custom_code: '',
                english: '29',
            },
            {
                code: '30',
                custom_code: '',
                english: '30',
            },
            {
                code: '31',
                custom_code: '',
                english: '31',
            },
            {
                code: 'Unknown',
                custom_code: '',
                english: 'Unknown',
            },
        ],
        Month: [
            {
                code: '1',
                custom_code: '',
                english: '1-January',
            },
            {
                code: '2',
                custom_code: '',
                english: '2-February',
            },
            {
                code: '3',
                custom_code: '',
                english: '3-March',
            },
            {
                code: '4',
                custom_code: '',
                english: '4-April',
            },
            {
                code: '5',
                custom_code: '',
                english: '5-May',
            },
            {
                code: '6',
                custom_code: '',
                english: '6-June',
            },
            {
                code: '7',
                custom_code: '',
                english: '7-July',
            },
            {
                code: '8',
                custom_code: '',
                english: '8-August',
            },
            {
                code: '9',
                custom_code: '',
                english: '9-September',
            },
            {
                code: '10',
                custom_code: '',
                english: '10-October',
            },
            {
                code: '11',
                custom_code: '',
                english: '11-November',
            },
            {
                code: '12',
                custom_code: '',
                english: '12-December',
            },
            {
                code: '99',
                custom_code: '',
                english: 'Unknown',
            },
        ],
        Frequency: [
            {
                code: '1',
                custom_code: '',
                english: 'One Time Only',
            },
            {
                code: '2',
                custom_code: '',
                english: 'Once a Day',
            },
            {
                code: '3',
                custom_code: '',
                english: 'Twice a Day',
            },
            {
                code: '4',
                custom_code: '',
                english: 'Three Times a Day',
            },
            {
                code: '5',
                custom_code: '',
                english: 'Four Times a Day',
            },
            {
                code: '6',
                custom_code: '',
                english: 'Weekly',
            },
            {
                code: '7',
                custom_code: '',
                english: 'Monthly',
            },
            {
                code: '8',
                custom_code: '',
                english: 'Other',
            },
        ],
        Severity: [
            {
                code: '1',
                custom_code: '',
                english: 'Mild',
            },
            {
                code: '2',
                custom_code: '',
                english: 'Moderate',
            },
            {
                code: '3',
                custom_code: '',
                english: 'Severe',
            },
        ],
        AE_Action: [
            {
                code: '1',
                custom_code: '',
                english: 'None',
            },
            {
                code: '2',
                custom_code: '',
                english: 'Reduced Intake',
            },
            {
                code: '4',
                custom_code: '',
                english: 'Product Suspended',
            },
            {
                code: '5',
                custom_code: '',
                english: 'Product Discontinued',
            },
            {
                code: '6',
                custom_code: '',
                english: 'Other',
            },
        ],
        Relationship: [
            {
                code: '1',
                custom_code: '',
                english: 'Unrelated',
            },
            {
                code: '2',
                custom_code: '',
                english: 'Unlikely',
            },
            {
                code: '3',
                custom_code: '',
                english: 'Possible',
            },
            {
                code: '4',
                custom_code: '',
                english: 'Probable',
            },
            {
                code: '5',
                custom_code: '',
                english: 'Certain',
            },
        ],
        Outcome: [
            {
                code: '1',
                custom_code: '',
                english: 'Fatal',
            },
            {
                code: '2',
                custom_code: '',
                english: 'Not Recovered/Not Resolved',
            },
            {
                code: '3',
                custom_code: '',
                english: 'Recovered with Sequelae',
            },
            {
                code: '4',
                custom_code: '',
                english: 'Recovered without Sequelae',
            },
            {
                code: '5',
                custom_code: '',
                english: 'Unknown',
            },
        ],
        SAE_ReportType: [
            {
                code: '1',
                custom_code: '',
                english: 'Initial',
            },
            {
                code: '2',
                custom_code: '',
                english: 'Additional',
            },
        ],
        Seriousness: [
            {
                code: '1',
                custom_code: '',
                english: 'Life Threatening',
            },
            {
                code: '2',
                custom_code: '',
                english: 'Hospitalization',
            },
            {
                code: '3',
                custom_code: '',
                english: 'Prolongation of Hospitalization',
            },
            {
                code: '4',
                custom_code: '',
                english: 'Persistent Disability',
            },
            {
                code: '5',
                custom_code: '',
                english: 'Significant Disability',
            },
            {
                code: '6',
                custom_code: '',
                english: 'Congenital Anomaly',
            },
            {
                code: '7',
                custom_code: '',
                english: 'Birth Defect',
            },
            {
                code: '8',
                custom_code: '',
                english: 'Death',
            },
        ],
        Report_Type: [
            {
                code: '1',
                custom_code: '',
                english: 'CBC Report',
            },
            {
                code: '2',
                custom_code: '',
                english: 'Metabolic Panel Report',
            },
            {
                code: '3',
                custom_code: '',
                english: 'Liver Function Report',
            },
            {
                code: '4',
                custom_code: '',
                english: 'Iron Panel Report',
            },
        ],
        Timepoint: [
            {
                code: '1',
                custom_code: '',
                english: 'Screening',
            },
            {
                code: '2',
                custom_code: '',
                english: 'Baseline',
            },
            {
                code: '3',
                custom_code: '',
                english: 'Active Trial',
            },
        ],
        QOL_HealthStatus: [
            {
                code: '1',
                custom_code: '',
                english: 'Excellent',
            },
            {
                code: '2',
                custom_code: '',
                english: 'Very Good',
            },
            {
                code: '3',
                custom_code: '',
                english: 'Good',
            },
            {
                code: '4',
                custom_code: '',
                english: 'Fair',
            },
            {
                code: '5',
                custom_code: '',
                english: 'Poor',
            },
            {
                code: '99',
                custom_code: '',
                english: 'Declined to Answer',
            },
        ],
        QOL_Mobility: [
            {
                code: '1',
                custom_code: '',
                english: 'Yes, Limited a Lot',
            },
            {
                code: '2',
                custom_code: '',
                english: 'Yes, Limited a Little',
            },
            {
                code: '3',
                custom_code: '',
                english: 'No, Not Limited at All',
            },
            {
                code: '99',
                custom_code: '',
                english: 'Declined to Answer',
            },
        ],
        QOL_Climbing: [
            {
                code: '1',
                custom_code: '',
                english: 'Yes, Limited a Lot',
            },
            {
                code: '2',
                custom_code: '',
                english: 'Yes, Limited a Little',
            },
            {
                code: '3',
                custom_code: '',
                english: 'No, Not Limited at All',
            },
            {
                code: '99',
                custom_code: '',
                english: 'Declined to Answer',
            },
        ],
        QOL_Timepoints: [
            {
                code: '1',
                custom_code: '',
                english: 'All of the Time',
            },
            {
                code: '2',
                custom_code: '',
                english: 'Most of the Time',
            },
            {
                code: '3',
                custom_code: '',
                english: 'Some of the Time',
            },
            {
                code: '4',
                custom_code: '',
                english: 'A Little of the Time',
            },
            {
                code: '5',
                custom_code: '',
                english: 'None of the Time',
            },
            {
                code: '99',
                custom_code: '',
                english: 'Declined to Answer',
            },
        ],
        QOL_Interference: [
            {
                code: '1',
                custom_code: '',
                english: 'Not at All',
            },
            {
                code: '2',
                custom_code: '',
                english: 'A Little Bit',
            },
            {
                code: '3',
                custom_code: '',
                english: 'Moderate',
            },
            {
                code: '4',
                custom_code: '',
                english: 'Quite a Bit',
            },
            {
                code: '5',
                custom_code: '',
                english: 'Extreme',
            },
            {
                code: '99',
                custom_code: '',
                english: 'Declined to Answer',
            },
        ],
        RTI_Severity: [
            {
                code: '99',
                custom_code: '',
                english: 'Not Present',
                text_en: 'Not Present',
            },
            {
                code: '1',
                custom_code: '',
                english: '(1) Mild',
                text_en: '(1) Mild',
            },
            {
                code: '2',
                custom_code: '',
                english: '(2) Moderate',
                text_en: '(2) Moderate',
            },
            {
                code: '3',
                custom_code: '',
                english: '(3) Severe',
                text_en: '(3) Severe',
            },
        ],
        Report_Result: [
            {
                code: '1',
                custom_code: '',
                english: 'Normal',
            },
            {
                code: '2',
                custom_code: '',
                english: 'Elevated',
            },
            {
                code: '3',
                custom_code: '',
                english: 'High',
            },
            {
                code: '4',
                custom_code: '',
                english: 'Low',
            },
            {
                code: '5',
                custom_code: '',
                english: 'Positive',
            },
            {
                code: '6',
                custom_code: '',
                english: 'Negative',
            },
        ],
        Lookup_Names: [
            {
                code: 'Dr. Zhaoping Li',
                custom_code: '',
                english: 'Dr. Zhaoping Li',
            },
            {
                code: 'Dr. Joseph Yusin',
                custom_code: '',
                english: 'Dr. Joseph Yusin',
            },
            {
                code: 'Dr. Carl Burton',
                custom_code: '',
                english: 'Dr. Carl Burton',
            },
            {
                code: 'Dr. Vivek Singh',
                custom_code: '',
                english: 'Dr. Vivek Singh',
            },
            {
                code: 'Irene Gilbuena LVN',
                custom_code: '',
                english: 'Irene Gilbuena LVN',
            },
            {
                code: 'Gail Thames',
                custom_code: '',
                english: 'Gail Thames',
            },
            {
                code: 'Dr. Rabie Shazahd',
                custom_code: '',
                english: 'Dr. Rabie Shazahd',
            },
            {
                code: 'Dr. Anastasia Chemeritskaya',
                custom_code: '',
                english: 'Dr. Anastasia Chemeritskaya',
            },
        ],
        dose_type: [
            {
                code: '1',
                custom_code: '',
                english: 'Initial Vaccination',
            },
            {
                code: '2',
                custom_code: '',
                english: 'Booster',
            },
        ],
        covid_collection_timepoints: [
            {
                code: '1',
                custom_code: '',
                english: 'Study Day 45',
            },
            {
                code: '2',
                custom_code: '',
                english: 'Study Day 90',
            },
        ],
        non_randomization_reason: [
            {
                code: 'SF',
                custom_code: '',
                english: 'Screen Failure',
            },
            {
                code: 'NR',
                custom_code: '',
                english: 'Not Randomized  (i.e. Qualified but Study Full)',
            },
            {
                code: 'SW',
                custom_code: '',
                english: 'Subject Withdrew Consent',
            },
            {
                code: 'Other',
                custom_code: '',
                english: 'Other (Specify)',
            },
        ],
        discontinuation_reason: [
            {
                code: 'SW',
                custom_code: '',
                english: 'Subject Withdrew Consent',
            },
            {
                code: 'IW',
                custom_code: '',
                english: 'Investigator or Sponsor Decided to Withdraw Subject',
            },
            {
                code: 'AE',
                custom_code: '',
                english: 'Adverse Event (Specify Name of Event)',
            },
            {
                code: 'Other',
                custom_code: '',
                english: 'Other (Specify)',
            },
        ],
        is_currently_taking: [
            {
                code: '1',
                custom_code: '',
                english: 'Yes',
            },
            {
                code: '0',
                custom_code: '',
                english: 'No',
            },
            {
                code: '-1',
                custom_code: '',
                english: 'Not yet known',
            },
        ],
        withdraw_reasons: [
            {
                code: '1',
                custom_code: '',
                english: 'Subject/LAR withdrew consent',
            },
            {
                code: '2',
                custom_code: '',
                english: 'Investigator or Sponsor decided to withdraw consent',
            },
            {
                code: '3',
                custom_code: '',
                english: 'Adverse Event',
            },
            {
                code: '4',
                custom_code: '',
                english: 'Other',
            },
        ],
        collection_timepoints: [
            {
                code: 'PREB',
                custom_code: '',
                english:
                    'Pre-booster: Collect (1) 10-ml gold top (SST) & (1) 5-ml gold top (SST) – Cytokines & HAI',
            },
            {
                code: 'PBD2',
                custom_code: '',
                english: 'Post-booster day 2: Collect (1) 7-ml gold top (SST) – Cytokines only',
            },
            {
                code: 'PBD7',
                custom_code: '',
                english: 'Post-booster day 7: Collect (1) 7-ml gold top (SST) – Cytokines only',
            },
            {
                code: 'PBD28',
                custom_code: '',
                english: 'Post-booster day 28: Collect (1) 5-ml gold top (SST) – HAI only',
            },
        ],
        note_type: [
            {
                code: '1',
                custom_code: '',
                english: 'Medical Record Note',
            },
            {
                code: '2',
                custom_code: '',
                english: 'Note for Primary Investigator',
            },
            {
                code: '3',
                custom_code: '',
                english: 'Note for Technical Support',
            },
        ],
        improvement_event_after_stopping: [
            {
                code: '0',
                custom_code: '',
                english: 'No',
            },
            {
                code: '1',
                custom_code: '',
                english: 'Yes',
            },
            {
                code: '2',
                custom_code: '',
                english: 'Not Applicable',
            },
        ],
        stop_status: [
            {
                code: '1',
                custom_code: '',
                english: 'Stopped',
            },
            {
                code: '2',
                custom_code: '',
                english: 'Stabilized',
            },
            {
                code: '3',
                custom_code: '',
                english: 'Ongoing',
            },
            {
                code: '4',
                custom_code: '',
                english: 'Death',
            },
        ],
        was_product_readministered: [
            {
                code: '0',
                custom_code: '',
                english: 'No',
            },
            {
                code: '1',
                custom_code: '',
                english: 'Yes',
            },
            {
                code: '2',
                custom_code: '',
                english: 'Not Applicable',
            },
        ],
        task_close_reason: [
            {
                code: '1',
                custom_code: '',
                english: 'Task Finished Normally',
            },
            {
                code: '2',
                custom_code: '',
                english: 'Task Failed Due to Time Limit',
            },
            {
                code: '3',
                custom_code: '',
                english: 'Task Failed Due to Invalid Condition',
            },
            {
                code: '4',
                custom_code: '',
                english: 'Task No Longer Needed',
            },
            {
                code: '5',
                custom_code: '',
                english: 'Task Finished (Other)',
            },
        ],
        supplement_options: [
            {
                code: '0',
                custom_code: '',
                english: '0',
            },
            {
                code: '1',
                custom_code: '',
                english: '1',
            },
            {
                code: '2',
                custom_code: '',
                english: '2',
            },
        ],
        is_mixed_options: [
            {
                code: 'Y',
                custom_code: '',
                english: 'Yes',
            },
            {
                code: 'N',
                custom_code: '',
                english: 'No',
            },
            {
                code: 'UNK',
                custom_code: '',
                english: 'Unknown',
            },
        ],
        audit_event_type: [
            {
                code: '0',
                custom_code: '',
                english: 'Status Changed',
            },
            {
                code: '1',
                custom_code: '',
                english: 'Participant Note',
            },
            {
                code: '95',
                custom_code: '',
                english: 'Record Lock',
            },
            {
                code: '96',
                custom_code: '',
                english: 'Page Load',
            },
            {
                code: '97',
                custom_code: '',
                english: 'Database Field Change',
            },
            {
                code: '98',
                custom_code: '',
                english: 'Automatic Database Audit',
            },
            {
                code: '99',
                custom_code: '',
                english: 'Other System Event',
            },
        ],
        Vaccination_type: [
            {
                code: '1',
                custom_code: '',
                english: 'Flu',
            },
            {
                code: '2',
                custom_code: '',
                english: 'COVID',
            },
        ],
        product_materials: [
            {
                code: '0',
                custom_code: '',
                english: 'Microcrystalline Cellulose',
            },
            {
                code: '1',
                custom_code: '',
                english: 'Rice Bran',
            },
            {
                code: '2',
                custom_code: '',
                english: 'Silica',
            },
            {
                code: '3',
                custom_code: '',
                english: 'Exberry® Turmeric Yellow Powder',
            },
            {
                code: '4',
                custom_code: '',
                english: 'Exberry ™ Shade Intense Pink Powder',
            },
        ],
    },
    tables: {
        ExceptionConditions: [
            {
                tableName: 'Table443',
                data: [
                    {
                        condition_name: 'sedimentation_rate',
                        condition_type: 'LowerRange',
                        value: '10',
                        indication_en: 'L',
                    },
                    {
                        condition_name: 'sedimentation_rate',
                        condition_type: 'UpperRange',
                        value: '100',
                        indication_en: 'H',
                    },
                    {
                        condition_name: 'wbc',
                        condition_type: 'LowerRange',
                        value: '4.5',
                        indication_en: 'L',
                    },
                    {
                        condition_name: 'wbc',
                        condition_type: 'UpperRange',
                        value: '11',
                        indication_en: 'H',
                    },
                    {
                        condition_name: 'rbc',
                        condition_type: 'LowerRange',
                        value: '4.4',
                        indication_en: 'L',
                    },
                    {
                        condition_name: 'rbc',
                        condition_type: 'UpperRange',
                        value: '5.9',
                        indication_en: 'H',
                    },
                    {
                        condition_name: 'hgb',
                        condition_type: 'LowerRange',
                        value: '13.3',
                        indication_en: 'L',
                    },
                    {
                        condition_name: 'hgb',
                        condition_type: 'UpperRange',
                        value: '17.7',
                        indication_en: 'H',
                    },
                    {
                        condition_name: 'hct',
                        condition_type: 'LowerRange',
                        value: '39',
                        indication_en: 'L',
                    },
                    {
                        condition_name: 'hct',
                        condition_type: 'UpperRange',
                        value: '52',
                        indication_en: 'H',
                    },
                    {
                        condition_name: 'mcv',
                        condition_type: 'LowerRange',
                        value: '80',
                        indication_en: 'L',
                    },
                    {
                        condition_name: 'mcv',
                        condition_type: 'UpperRange',
                        value: '99',
                        indication_en: 'H',
                    },
                    {
                        condition_name: 'mch',
                        condition_type: 'LowerRange',
                        value: '27',
                        indication_en: 'L',
                    },
                    {
                        condition_name: 'mch',
                        condition_type: 'UpperRange',
                        value: '34',
                        indication_en: 'H',
                    },
                    {
                        condition_name: 'mchc',
                        condition_type: 'LowerRange',
                        value: '32',
                        indication_en: 'L',
                    },
                    {
                        condition_name: 'mchc',
                        condition_type: 'UpperRange',
                        value: '36',
                        indication_en: 'H',
                    },
                    {
                        condition_name: 'rdw',
                        condition_type: 'LowerRange',
                        value: '12',
                        indication_en: 'L',
                    },
                    {
                        condition_name: 'rdw',
                        condition_type: 'UpperRange',
                        value: '15',
                        indication_en: 'H',
                    },
                    {
                        condition_name: 'platelets',
                        condition_type: 'LowerRange',
                        value: '150',
                        indication_en: 'L',
                    },
                    {
                        condition_name: 'platelets',
                        condition_type: 'UpperRange',
                        value: '440',
                        indication_en: 'H',
                    },
                    {
                        condition_name: 'neutrophils_percent',
                        condition_type: 'LowerRange',
                        value: '41',
                        indication_en: 'L',
                    },
                    {
                        condition_name: 'neutrophils_percent',
                        condition_type: 'UpperRange',
                        value: '85',
                        indication_en: 'H',
                    },
                    {
                        condition_name: 'lymphocytes_percent',
                        condition_type: 'LowerRange',
                        value: '20',
                        indication_en: 'L',
                    },
                    {
                        condition_name: 'lymphocytes_percent',
                        condition_type: 'UpperRange',
                        value: '40',
                        indication_en: 'H',
                    },
                    {
                        condition_name: 'monocytes_percent',
                        condition_type: 'LowerRange',
                        value: '2',
                        indication_en: 'L',
                    },
                    {
                        condition_name: 'monocytes_percent',
                        condition_type: 'UpperRange',
                        value: '10',
                        indication_en: 'H',
                    },
                    {
                        condition_name: 'eosinophils_percent',
                        condition_type: 'LowerRange',
                        value: '1',
                        indication_en: 'L',
                    },
                    {
                        condition_name: 'eosinophils_percent',
                        condition_type: 'UpperRange',
                        value: '6',
                        indication_en: 'H',
                    },
                    {
                        condition_name: 'basophils_percent',
                        condition_type: 'LowerRange',
                        value: '0',
                        indication_en: 'L',
                    },
                    {
                        condition_name: 'basophils_percent',
                        condition_type: 'UpperRange',
                        value: '1',
                        indication_en: 'H',
                    },
                    {
                        condition_name: 'ig_percent',
                        condition_type: 'LowerRange',
                        value: '0',
                        indication_en: 'L',
                    },
                    {
                        condition_name: 'ig_percent',
                        condition_type: 'UpperRange',
                        value: '0.9',
                        indication_en: 'H',
                    },
                    {
                        condition_name: 'nrbc_percent',
                        condition_type: 'ExceptThisValue',
                        value: '0',
                    },
                    {
                        condition_name: 'neutrophils',
                        condition_type: 'LowerRange',
                        value: '1100',
                        indication_en: 'L',
                    },
                    {
                        condition_name: 'neutrophils',
                        condition_type: 'UpperRange',
                        value: '7700',
                        indication_en: 'H',
                    },
                    {
                        condition_name: 'lymphocytes',
                        condition_type: 'LowerRange',
                        value: '600',
                        indication_en: 'L',
                    },
                    {
                        condition_name: 'lymphocytes',
                        condition_type: 'UpperRange',
                        value: '4800',
                        indication_en: 'H',
                    },
                    {
                        condition_name: 'monocytes',
                        condition_type: 'LowerRange',
                        value: '0',
                        indication_en: 'L',
                    },
                    {
                        condition_name: 'monocytes',
                        condition_type: 'UpperRange',
                        value: '950',
                        indication_en: 'H',
                    },
                    {
                        condition_name: 'eosinophils',
                        condition_type: 'LowerRange',
                        value: '0',
                        indication_en: 'L',
                    },
                    {
                        condition_name: 'eosinophils',
                        condition_type: 'UpperRange',
                        value: '500',
                        indication_en: 'H',
                    },
                    {
                        condition_name: 'basophils',
                        condition_type: 'LowerRange',
                        value: '0',
                        indication_en: 'L',
                    },
                    {
                        condition_name: 'basophils',
                        condition_type: 'UpperRange',
                        value: '200',
                        indication_en: 'H',
                    },
                    {
                        condition_name: 'ig',
                        condition_type: 'LowerRange',
                        value: '0',
                        indication_en: 'L',
                    },
                    {
                        condition_name: 'ig',
                        condition_type: 'UpperRange',
                        value: '60',
                        indication_en: 'H',
                    },
                    {
                        condition_name: 'nrbc',
                        condition_type: 'ExceptThisValue',
                        value: '0',
                    },
                    {
                        condition_name: 'sodium',
                        condition_type: 'LowerRange',
                        value: '136',
                        indication_en: 'L',
                    },
                    {
                        condition_name: 'sodium',
                        condition_type: 'UpperRange',
                        value: '146',
                        indication_en: 'H',
                    },
                    {
                        condition_name: 'potassium',
                        condition_type: 'LowerRange',
                        value: '3.5',
                        indication_en: 'L',
                    },
                    {
                        condition_name: 'potassium',
                        condition_type: 'UpperRange',
                        value: '5.3',
                        indication_en: 'H',
                    },
                    {
                        condition_name: 'chloride',
                        condition_type: 'LowerRange',
                        value: '95',
                        indication_en: 'L',
                    },
                    {
                        condition_name: 'chloride',
                        condition_type: 'UpperRange',
                        value: '110',
                        indication_en: 'H',
                    },
                    {
                        condition_name: 'co2',
                        condition_type: 'LowerRange',
                        value: '21',
                        indication_en: 'L',
                    },
                    {
                        condition_name: 'co2',
                        condition_type: 'UpperRange',
                        value: '31',
                        indication_en: 'H',
                    },
                    {
                        condition_name: 'urea_nitrogen',
                        condition_type: 'LowerRange',
                        value: '5',
                        indication_en: 'L',
                    },
                    {
                        condition_name: 'urea_nitrogen',
                        condition_type: 'UpperRange',
                        value: '25',
                        indication_en: 'H',
                    },
                    {
                        condition_name: 'creatinine',
                        condition_type: 'LowerRange',
                        value: '0.66',
                        indication_en: 'L',
                    },
                    {
                        condition_name: 'creatinine',
                        condition_type: 'UpperRange',
                        value: '1.28',
                        indication_en: 'H',
                    },
                    {
                        condition_name: 'egfr',
                        condition_type: 'LowerRange',
                        value: '38',
                        indication_en: 'L',
                    },
                    {
                        condition_name: 'egfr',
                        condition_type: 'UpperRange',
                        value: '180',
                        indication_en: 'H',
                    },
                    {
                        condition_name: 'glucose',
                        condition_type: 'LowerRange',
                        value: '70',
                        indication_en: 'L',
                    },
                    {
                        condition_name: 'glucose',
                        condition_type: 'UpperRange',
                        value: '110',
                        indication_en: 'H',
                    },
                    {
                        condition_name: 'calcium',
                        condition_type: 'LowerRange',
                        value: '8.4',
                        indication_en: 'L',
                    },
                    {
                        condition_name: 'calcium',
                        condition_type: 'UpperRange',
                        value: '10.2',
                        indication_en: 'H',
                    },
                    {
                        condition_name: 'magnesium',
                        condition_type: 'LowerRange',
                        value: '1.8',
                        indication_en: 'L',
                    },
                    {
                        condition_name: 'magnesium',
                        condition_type: 'UpperRange',
                        value: '2.4',
                        indication_en: 'H',
                    },
                    {
                        condition_name: 'phosphorus',
                        condition_type: 'LowerRange',
                        value: '2.5',
                        indication_en: 'L',
                    },
                    {
                        condition_name: 'phosphorus',
                        condition_type: 'UpperRange',
                        value: '4.9',
                        indication_en: 'H',
                    },
                    {
                        condition_name: 'alkaline_phosphatase',
                        condition_type: 'LowerRange',
                        value: '33',
                        indication_en: 'L',
                    },
                    {
                        condition_name: 'alkaline_phosphatase',
                        condition_type: 'UpperRange',
                        value: '94',
                        indication_en: 'H',
                    },
                    {
                        condition_name: 'alanine_aminotransferase',
                        condition_type: 'LowerRange',
                        value: '7',
                        indication_en: 'L',
                    },
                    {
                        condition_name: 'alanine_aminotransferase',
                        condition_type: 'UpperRange',
                        value: '45',
                        indication_en: 'H',
                    },
                    {
                        condition_name: 'bilirubin',
                        condition_type: 'LowerRange',
                        value: '0.2',
                        indication_en: 'L',
                    },
                    {
                        condition_name: 'bilirubin',
                        condition_type: 'UpperRange',
                        value: '1',
                        indication_en: 'H',
                    },
                    {
                        condition_name: 'albumin',
                        condition_type: 'LowerRange',
                        value: '3.2',
                        indication_en: 'L',
                    },
                    {
                        condition_name: 'albumin',
                        condition_type: 'UpperRange',
                        value: '4.8',
                        indication_en: 'H',
                    },
                ],
            },
        ],
        Participant: [
            {
                tableName: 'Table1',
                data: [
                    {
                        field: 'id',
                        field_label_en: 'Participant Index',
                        field_type: 'ID',
                        validation_name: 'NotEmpty',
                        export_id: 'ID',
                    },
                    {
                        field: 'uuid',
                        field_label_en: 'Participant ID (10 Digit Number)',
                        field_type: 'TextParticipantId',
                        validation_name: 'PatternMatch',
                        options: '^[0-9]{3}.[0-9]{3}.[0-9]{4}$',
                        export_id: 'UUID',
                    },
                    {
                        field: 'subject_id',
                        field_label_en: 'Subject ID',
                        field_type: 'Number',
                        export_id: 'SUBJECT_ID',
                    },
                    {
                        field: 'group_id',
                        field_label_en: 'Group ID',
                        field_type: 'Text',
                        blinded: 'Yes',
                        export_id: 'GROUP_ID',
                    },
                    {
                        field: 'status',
                        field_label_en: 'Status',
                        field_type: 'Lookup',
                        validation_name: 'NotEmpty',
                        default_value: 'C',
                        export_id: 'STATUS',
                    },
                    {
                        field: 'phase',
                        field_label_en: 'Study Phase',
                        field_type: 'Lookup',
                        validation_name: 'NotEmpty',
                        default_value: '1',
                        export_id: 'PHASE',
                    },
                    {
                        field: 'site_loc_id',
                        field_label_en: 'Site Location',
                        field_type: 'Foreign Key',
                        validation_name: 'NotEmpty',
                        related_table: 'SiteLocation',
                        export_id: 'SITE_LOC_ID',
                    },
                    {
                        field: 'first_name',
                        field_label_en: 'First Name',
                        field_type: 'Text',
                        validation_name: 'NotEmpty',
                        blinded: 'Yes',
                        pii: 'Yes',
                        export_id: 'FIRST_NAME',
                    },
                    {
                        field: 'last_name',
                        field_label_en: 'Last Name',
                        field_type: 'Text',
                        validation_name: 'NotEmpty',
                        pii: 'Yes',
                        export_id: 'LAST_NAME',
                    },
                    {
                        field: 'birthdate',
                        field_label_en: 'Birthdate',
                        field_type: 'Date',
                        validation_name: 'Range',
                        min_count: '1899-12-31T05:00:00.000Z',
                        max_count: '1967-01-01T05:00:00.000Z',
                        pii: 'Yes',
                        export_id: 'BIRTHDATE',
                    },
                    {
                        field: 'trial_start_date',
                        field_label_en: 'Trial Start',
                        field_type: 'Date',
                        export_id: 'TRIAL_START_DATE',
                    },
                    {
                        field: 'screenfailed_reason',
                        field_label_en: 'Screen Failed Reason',
                        field_type: 'Text',
                        export_id: 'SCREENFAILED_REASON',
                    },
                    {
                        field: 'screenfailed_dt',
                        field_label_en: 'Screen Failed Date',
                        field_type: 'DateTime',
                        export_id: 'SCREENFAILED_DT',
                    },
                    {
                        field: 'withdraw_reason',
                        field_label_en: 'Withdraw Reason',
                        field_type: 'Text',
                        export_id: 'WITHDRAW_REASON',
                    },
                    {
                        field: 'withdraw_dt',
                        field_label_en: 'Withdraw Date',
                        field_type: 'DateTime',
                        export_id: 'WITHDRAW_DT',
                    },
                    {
                        field: 'withdraw_by',
                        field_label_en: 'Withdraw By',
                        field_type: 'Lookup',
                        related_table: 'Lookup_Names',
                        export_id: 'WITHDRAW_BY',
                    },
                    {
                        field: 'enrolled_dt',
                        field_label_en: 'Enrolled Date',
                        field_type: 'DateTime',
                        export_id: 'ENROLLED_DT',
                    },
                    {
                        field: 'enrolled_by',
                        field_label_en: 'Enrolled By',
                        field_type: 'Lookup',
                        related_table: 'Lookup_Names',
                        export_id: 'ENROLLED_BY',
                    },
                    {
                        field: 'approved_dt',
                        field_label_en: 'Approved Date',
                        field_type: 'DateTime',
                        export_id: 'APPROVED_DT',
                    },
                    {
                        field: 'approved_by',
                        field_label_en: 'Approved By',
                        field_type: 'Lookup',
                        related_table: 'Lookup_Names',
                        export_id: 'APPROVED_BY',
                    },
                    {
                        field: 'randomized_dt',
                        field_label_en: 'Randomized Date',
                        field_type: 'DateTime',
                        export_id: 'RANDOMIZED_DT',
                    },
                    {
                        field: 'randomized_by',
                        field_label_en: 'Randomized By',
                        field_type: 'Lookup',
                        related_table: 'Lookup_Names',
                        export_id: 'RANDOMIZED_BY',
                    },
                    {
                        field: 'last_rti_alert_day',
                        field_label_en: 'Last trial day number for an alert',
                        field_type: 'Number',
                        default_value: '-21',
                        export_id: 'LAST_RTI_ALERT_DAY',
                    },
                    {
                        field: 'last_clean_day',
                        field_label_en: 'Last trial day without symptoms',
                        field_type: 'Number',
                        default_value: '-21',
                        export_id: 'LAST_CLEAN_DAY',
                    },
                    {
                        field: 'lock_status',
                        field_label_en: 'Lock Status',
                        field_type: 'Boolean',
                        export_id: 'LOCK_STATUS',
                    },
                    {
                        field: 'lock_by',
                        field_label_en: 'Locked by',
                        field_type: 'Lookup',
                        related_table: 'Lookup_Names',
                        export_id: 'LOCK_BY',
                    },
                    {
                        field: 'lock_dt',
                        field_label_en: 'Lock date',
                        field_type: 'DateTime',
                        export_id: 'LOCK_DT',
                    },
                    {
                        field: 'trial_day_num',
                        field_label_en: 'Current Trial Day',
                        field_type: 'Number',
                        validation_name: 'Calculation',
                        export_id: 'TRIAL_DAY_NUM',
                    },
                    {
                        field: 'has_completed_consent',
                        field_label_en: 'Consent Forms Are Current',
                        field_type: 'Boolean',
                        validation_name: 'Calculation',
                        default_value: 'false',
                        export_id: 'HAS_COMPLETED_CONSENT',
                    },
                    {
                        field: 'has_completed_ie',
                        field_label_en: 'Inclusion Exclusions Are Met',
                        field_type: 'Boolean',
                        validation_name: 'Calculation',
                        default_value: 'false',
                        export_id: 'HAS_COMPLETED_IE',
                    },
                    {
                        field: 'tasks_pending',
                        field_label_en: 'Tasks Pending',
                        field_type: 'Number',
                        validation_name: 'Calculation',
                        export_id: 'TASKS_PENDING',
                    },
                    {
                        field: 'age',
                        field_label_en: 'Age When Starting Trial',
                        field_type: 'Number',
                        validation_name: 'Calculation',
                        options: '{{ms_to_years(ellapsed_time(now(), birthdate))}}',
                        export_id: 'AGE',
                    },
                ],
            },
        ],
        Audit: [
            {
                tableName: 'Table120',
                data: [
                    {
                        field: 'id',
                        field_label_en: 'Unique Event ID',
                        field_type: 'ID',
                        export_id: 'ID',
                    },
                    {
                        field: 'participant_id',
                        field_label_en: 'Participant ID',
                        field_type: 'Foreign Key',
                        related_table: 'Participant',
                        export_id: 'PARTICIPANT_ID',
                    },
                    {
                        field: 'event_dt',
                        field_label_en: 'Event Date',
                        field_type: 'DateTime',
                        default_value: '{{now()}}',
                        export_id: 'EVENT_DT',
                    },
                    {
                        field: 'event_dt_local',
                        field_label_en: 'Event Date Local',
                        field_type: 'Text',
                        export_id: 'EVENT_DT_LOCAL',
                    },
                    {
                        field: 'timezone_offset',
                        field_label_en: 'Event Date Offset',
                        field_type: 'Number',
                        edit_group: 'TIMEZONE_OFFSET',
                        export_id: 'TIMEZONE_OFFSET',
                    },
                    {
                        field: 'event_type',
                        field_label_en: 'Event Type',
                        field_type: 'Lookup',
                        options: 'audit_event_type',
                        export_id: 'EVENT_TYPE',
                    },
                    {
                        field: 'event_text',
                        field_label_en: 'Event Text',
                        field_type: 'Text',
                        export_id: 'EVENT_TEXT',
                    },
                    {
                        field: 'reported_dt',
                        field_label_en: 'Reported On',
                        field_type: 'DateTime',
                        export_id: 'REPORTED_DT',
                    },
                    {
                        field: 'reported_by',
                        field_label_en: 'Reported By',
                        field_type: 'Foreign Key',
                        related_table: 'users',
                        export_id: 'REPORTED_BY',
                    },
                    {
                        field: 'reported_device',
                        field_label_en: 'Reporting Device',
                        field_type: 'Text',
                        export_id: 'REPORTED_DEVICE',
                    },
                    {
                        field: 'reported_ip',
                        field_label_en: 'Reporting IP Address',
                        field_type: 'Text',
                        export_id: 'REPORTED_IP',
                    },
                    {
                        field: 'linked_route',
                        field_label_en: 'Linked Route',
                        field_type: 'Text',
                        export_id: 'LINKED_ROUTE',
                    },
                    {
                        field: 'linked_route_id',
                        field_label_en: 'Linked Route Reference ID',
                        field_type: 'Text',
                        export_id: 'LINKED_ROUTE_ID',
                    },
                    {
                        field: 'reference_id',
                        field_label_en: 'Reference ID',
                        field_type: 'Text',
                        export_id: 'REFERENCE_ID',
                    },
                ],
            },
        ],
        MedicalHistory: [
            {
                tableName: 'Table110151022',
                data: [
                    {
                        field: 'id',
                        field_label_en: 'Record ID',
                        field_type: 'ID',
                        export_name: 'ID',
                    },
                    {
                        field: 'participant_id',
                        field_label_en: 'Participant ID',
                        field_type: 'Foreign Key',
                        related_table: 'Participant',
                        export_name: 'PARTICIPANT_ID',
                    },
                    {
                        field: 'reported_dt',
                        field_label_en: 'Reported Date',
                        field_type: 'DateTime',
                        validation_name: 'NotEmpty',
                        default_value: '{{now()}}',
                        export_name: 'REPORTED_DT',
                    },
                    {
                        field: 'reported_by',
                        field_label_en: 'Reported By',
                        field_type: 'Foreign Key',
                        related_table: 'PortalUser',
                        export_name: 'REPORTED_BY',
                    },
                    {
                        field: 'created_dt',
                        field_label_en: 'Created On',
                        field_type: 'DateTime',
                        validation_name: 'NotEmpty',
                        default_value: '{{now()}}',
                        export_name: 'CREATED_DT',
                    },
                    {
                        field: 'created_by',
                        field_label_en: 'Created By',
                        field_type: 'Foreign Key',
                        related_table: 'PortalUser',
                        export_name: 'CREATED_BY',
                    },
                    {
                        field: 'medical_history_text',
                        field_label_en: 'Medical History Text',
                        field_type: 'Text',
                        validation_name: 'NotEmpty',
                        export_name: 'MEDICAL_HISTORY_TEXT',
                    },
                    {
                        field: 'onset_year',
                        field_label_en: 'Onset Year',
                        field_type: 'Year',
                        validation_name: 'NotEmpty',
                        export_name: 'ONSET_YEAR',
                    },
                    {
                        field: 'complications',
                        field_label_en: 'Complications',
                        field_type: 'Text',
                        validation_name: 'NotEmpty',
                        export_name: 'COMPLICATIONS',
                    },
                    {
                        field: 'lock_status',
                        field_label_en: 'Lock Status',
                        field_type: 'Boolean',
                        export_name: 'LOCK_STATUS',
                    },
                    {
                        field: 'lock_by',
                        field_label_en: 'Locked by',
                        field_type: 'Lookup',
                        related_table: 'Lookup_Names',
                        export_name: 'LOCK_BY',
                    },
                    {
                        field: 'lock_dt',
                        field_label_en: 'Lock date',
                        field_type: 'DateTime',
                        export_name: 'LOCK_DT',
                    },
                ],
            },
        ],
        TrueStart: [
            {
                tableName: 'Table11015103141',
                data: [
                    {
                        field: 'id',
                        field_type: 'ID',
                        export_name: 'ID',
                    },
                    {
                        field: 'participant_id',
                        field_label_en: 'Participant ID',
                        field_type: 'Foreign Key',
                        related_table: 'Participant',
                        export_name: 'PARTICIPANT_ID',
                    },
                    {
                        field: 'reported_dt',
                        field_label_en: 'Reported Date',
                        field_type: 'DateTime',
                        validation_name: 'NotEmpty',
                        default_value: '{{now()}}',
                        export_name: 'REPORTED_DT',
                    },
                    {
                        field: 'reported_by',
                        field_label_en: 'Reported By',
                        field_type: 'Foreign Key',
                        related_table: 'users',
                        export_name: 'REPORTED_BY',
                    },
                    {
                        field: 'created_dt',
                        field_label_en: 'Created On',
                        field_type: 'DateTime',
                        validation_name: 'NotEmpty',
                        default_value: '{{now()}}',
                        export_name: 'CREATED_DT',
                    },
                    {
                        field: 'created_by',
                        field_label_en: 'Created By',
                        field_type: 'Foreign Key',
                        related_table: 'users',
                        export_name: 'CREATED_BY',
                    },
                    {
                        field: 'true_start_dt',
                        field_label_en: 'True Start Date',
                        field_type: 'Date',
                        validation_name: 'NotEmpty',
                        export_name: 'TRUE_START_DT',
                    },
                    {
                        field: 'rti_confirm_start',
                        field_label_en: 'Confirm RTI',
                        field_type: 'Lookup',
                        validation_name: 'NotEmpty',
                        options: 'OptionalBoolean',
                        export_name: 'RTI_CONFIRM_START',
                    },
                ],
            },
        ],
        Medication: [
            {
                tableName: 'Table110151031',
                data: [
                    {
                        field: 'id',
                        field_type: 'ID',
                        export_name: 'ID',
                    },
                    {
                        field: 'participant_id',
                        field_label_en: 'Participant ID',
                        field_type: 'Foreign Key',
                        related_table: 'Participant',
                        export_name: 'PARTICIPANT_ID',
                    },
                    {
                        field: 'reported_dt',
                        field_label_en: 'Reported Date',
                        field_type: 'DateTime',
                        validation_name: 'NotEmpty',
                        default_value: '{{now()}}',
                        export_name: 'REPORTED_DT',
                    },
                    {
                        field: 'reported_by',
                        field_label_en: 'Reported By',
                        field_type: 'Foreign Key',
                        related_table: 'users',
                        export_name: 'REPORTED_BY',
                    },
                    {
                        field: 'created_dt',
                        field_label_en: 'Created On',
                        field_type: 'DateTime',
                        validation_name: 'NotEmpty',
                        default_value: '{{now()}}',
                        export_name: 'CREATED_DT',
                    },
                    {
                        field: 'created_by',
                        field_label_en: 'Created By',
                        field_type: 'Foreign Key',
                        related_table: 'users',
                        export_name: 'CREATED_BY',
                    },
                    {
                        field: 'whodrug_id',
                        field_label_en: 'WHODrug Code ID',
                        field_type: 'Number',
                        view_group: 'Coder',
                        export_name: 'WHODRUG_ID',
                    },
                    {
                        field: 'whodrug_name',
                        field_label_en: 'WHODrug Code Text',
                        field_type: 'Text',
                        view_group: 'Coder',
                        export_name: 'WHODRUG_NAME',
                    },
                    {
                        field: 'medication_name',
                        field_label_en: 'Drug Name',
                        field_type: 'Text',
                        validation_name: 'NotEmpty',
                        export_name: 'MEDICATION_NAME',
                    },
                    {
                        field: 'dose',
                        field_label_en: 'Dose',
                        field_type: 'Float',
                        validation_name: 'NotEmpty',
                        export_name: 'DOSE',
                    },
                    {
                        field: 'dose_units',
                        field_label_en: 'Dose Units',
                        field_type: 'Text',
                        validation_name: 'NotEmpty',
                        export_name: 'DOSE_UNITS',
                    },
                    {
                        field: 'dose_form',
                        field_label_en: 'Dose Form',
                        field_type: 'Lookup',
                        validation_name: 'NotEmpty',
                        options: 'dose_form',
                        export_name: 'DOSE_FORM',
                    },
                    {
                        field: 'dose_form_specify',
                        field_label_en: 'Other Dose Form (specify)',
                        field_type: 'Text',
                        validation_name: 'NotEmpty',
                        export_name: 'DOSE_FORM_SPECIFY',
                    },
                    {
                        field: 'dose_route',
                        field_label_en: 'Dose Route',
                        field_type: 'Lookup',
                        validation_name: 'NotEmpty',
                        options: 'dose_route',
                        export_name: 'DOSE_ROUTE',
                    },
                    {
                        field: 'dose_route_specify',
                        field_label_en: 'Other Dose Route (specify)',
                        field_type: 'Text',
                        validation_name: 'NotEmpty',
                        export_name: 'DOSE_ROUTE_SPECIFY',
                    },
                    {
                        field: 'start_day',
                        field_label_en: 'Start Day',
                        field_type: 'Lookup',
                        validation_name: 'NotEmpty',
                        options: 'Day',
                        export_name: 'START_DAY',
                    },
                    {
                        field: 'start_month',
                        field_label_en: 'Started Taking From Month',
                        field_type: 'Lookup',
                        validation_name: 'NotEmpty',
                        options: 'Month',
                        export_name: 'START_MONTH',
                    },
                    {
                        field: 'start_year',
                        field_label_en: 'Started Taking From Year',
                        field_type: 'Year',
                        validation_name: 'NotEmpty',
                        export_name: 'START_YEAR',
                    },
                    {
                        field: 'is_currently_taking',
                        field_label_en: 'Medication On-going',
                        field_type: 'Lookup',
                        validation_name: 'NotEmpty',
                        options: 'is_currently_taking',
                        export_name: 'IS_CURRENTLY_TAKING',
                    },
                    {
                        field: 'end_day',
                        field_label_en: 'Taken Until Day',
                        field_type: 'Lookup',
                        validation_name: 'NotEmpty',
                        options: 'Day',
                        export_name: 'END_DAY',
                    },
                    {
                        field: 'end_month',
                        field_label_en: 'Taken Until Month',
                        field_type: 'Lookup',
                        validation_name: 'NotEmpty',
                        options: 'Month',
                        export_name: 'END_MONTH',
                    },
                    {
                        field: 'end_year',
                        field_label_en: 'Taken Until Year',
                        field_type: 'Year',
                        validation_name: 'NotEmpty',
                        export_name: 'END_YEAR',
                    },
                    {
                        field: 'frequency',
                        field_label_en: 'Frequency',
                        field_type: 'Lookup',
                        validation_name: 'NotEmpty',
                        options: 'Frequency',
                        export_name: 'FREQUENCY',
                    },
                    {
                        field: 'frequency_specify',
                        field_label_en: 'Other (specify)',
                        field_type: 'Text',
                        validation_name: 'NotEmpty',
                        export_name: 'FREQUENCY_SPECIFY',
                    },
                    {
                        field: 'reason',
                        field_label_en: 'Indication for Use',
                        field_type: 'Text',
                        validation_name: 'NotEmpty',
                        export_name: 'REASON',
                    },
                    {
                        field: 'linked_to_rti',
                        field_label_en: 'Linked to RTI',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        export_name: 'LINKED_TO_RTI',
                    },
                    {
                        field: 'lock_status',
                        field_label_en: 'Lock Status',
                        field_type: 'Boolean',
                        edit_group: 'LOCK_STATUS',
                        export_name: 'LOCK_STATUS',
                    },
                    {
                        field: 'lock_by',
                        field_label_en: 'Locked by',
                        field_type: 'Lookup',
                        related_table: 'Lookup_Names',
                        edit_group: 'LOCK_BY',
                        export_name: 'LOCK_BY',
                    },
                    {
                        field: 'lock_dt',
                        field_label_en: 'Lock date',
                        field_type: 'DateTime',
                        export_name: 'LOCK_DT',
                    },
                ],
            },
        ],
        RandomizeStart: [
            {
                tableName: 'Table11015103137',
                data: [
                    {
                        field: 'id',
                        field_label_en: 'ID',
                        field_type: 'ID',
                        detail_group: 'General',
                        export_name: 'ID',
                    },
                    {
                        field: 'start_dt',
                        field_label_en: 'Start Date',
                        field_type: 'Date',
                        detail_group: 'General',
                        related_table: 'Detail',
                        export_name: 'START_DT',
                    },
                    {
                        field: 'created_dt',
                        field_label_en: 'Created On',
                        field_type: 'DateTime',
                        validation_name: 'NotEmpty',
                        detail_group: 'Tracking',
                        default_value: '{{now()}}',
                        export_name: 'CREATED_DT',
                    },
                    {
                        field: 'created_by',
                        field_label_en: 'Created By',
                        field_type: 'Foreign Key',
                        validation_name: 'NotEmpty',
                        detail_group: 'Tracking',
                        related_table: 'PortalUser',
                        export_name: 'CREATED_BY',
                    },
                    {
                        field: 'confirm_rti',
                        field_label_en: 'Confirmed RTI',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        detail_group: 'Tracking',
                        export_name: 'CONFIRM_RTI',
                    },
                    {
                        field: 'result',
                        field_label_en: 'Result',
                        field_type: 'Text',
                        detail_group: 'Tracking',
                        export_name: 'RESULT',
                    },
                    {
                        field: 'success',
                        field_label_en: 'Success Code',
                        field_type: 'Text',
                        detail_group: 'Tracking',
                        export_name: 'SUCCESS',
                    },
                ],
            },
        ],
        RtiComplications: [
            {
                tableName: 'Table110161828',
                data: [
                    {
                        field: 'id',
                        field_type: 'ID',
                        diagnosis_name: 'ID',
                    },
                    {
                        field: 'participant_id',
                        field_label_en: 'Participant ID',
                        field_type: 'Foreign Key',
                        related_table: 'Participant',
                        diagnosis_name: 'PARTICIPANT_ID',
                    },
                    {
                        field: 'reported_dt',
                        field_label_en: 'Reported Date',
                        field_type: 'DateTime',
                        validation_name: 'NotEmpty',
                        default_value: '{{now()}}',
                        diagnosis_name: 'REPORTED_DT',
                    },
                    {
                        field: 'reported_by',
                        field_label_en: 'Reported By',
                        field_type: 'Foreign Key',
                        related_table: 'PortalUser',
                        diagnosis_name: 'REPORTED_BY',
                    },
                    {
                        field: 'created_dt',
                        field_label_en: 'Created On',
                        field_type: 'DateTime',
                        validation_name: 'NotEmpty',
                        default_value: '{{now()}}',
                        diagnosis_name: 'CREATED_DT',
                    },
                    {
                        field: 'created_by',
                        field_label_en: 'Created By',
                        field_type: 'Foreign Key',
                        related_table: 'PortalUser',
                        diagnosis_name: 'CREATED_BY',
                    },
                    {
                        field: 'diagnosis_name',
                        field_label_en: 'Name of Diagnosis',
                        field_type: 'Text',
                        validation_name: 'NotEmpty',
                        diagnosis_name: 'DIAGNOSIS_NAME',
                    },
                    {
                        field: 'is_er_visit',
                        field_label_en: 'ER Visit',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        diagnosis_name: 'IS_ER_VISIT',
                    },
                    {
                        field: 'er_visit_start_dt',
                        field_label_en: 'ER Visit Start Date',
                        field_type: 'Date',
                        validation_name: 'NotEmpty',
                        diagnosis_name: 'ER_VISIT_START_DT',
                    },
                    {
                        field: 'er_visit_discharge_dt',
                        field_label_en: 'ER Visit Discharge Date',
                        field_type: 'Date',
                        validation_name: 'NotEmpty',
                        diagnosis_name: 'ER_VISIT_DISCHARGE_DT',
                    },
                    {
                        field: 'is_hospitalization',
                        field_label_en: 'Hospitalization',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        diagnosis_name: 'IS_HOSPITALIZATION',
                    },
                    {
                        field: 'hospitalization_admission_dt',
                        field_label_en: 'Hospitalization Admission Date',
                        field_type: 'Date',
                        validation_name: 'NotEmpty',
                        diagnosis_name: 'HOSPITALIZATION_ADMISSION_DT',
                    },
                    {
                        field: 'hospitalization_discharge_dt',
                        field_label_en: 'Hospitalization Discharge Date',
                        field_type: 'Date',
                        validation_name: 'NotEmpty',
                        diagnosis_name: 'HOSPITALIZATION_DISCHARGE_DT',
                    },
                    {
                        field: 'is_death',
                        field_label_en: 'Death',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        diagnosis_name: 'IS_DEATH',
                    },
                    {
                        field: 'death_dt',
                        field_label_en: 'Date of Death',
                        field_type: 'Date',
                        validation_name: 'NotEmpty',
                        diagnosis_name: 'DEATH_DT',
                    },
                    {
                        field: 'has_other_complication',
                        field_label_en: 'Other',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        diagnosis_name: 'HAS_OTHER_COMPLICATION',
                    },
                    {
                        field: 'other_specification',
                        field_label_en: 'Other Specification',
                        field_type: 'Text',
                        validation_name: 'NotEmpty',
                        diagnosis_name: 'OTHER_SPECIFICATION',
                    },
                    {
                        field: 'other_complication_start_dt',
                        field_label_en: 'Other Complication Start Date',
                        field_type: 'Date',
                        validation_name: 'NotEmpty',
                        diagnosis_name: 'OTHER_COMPLICATION_START_DT',
                    },
                    {
                        field: 'other_complication_stop_dt',
                        field_label_en: 'Other Complication Stop Date',
                        field_type: 'Date',
                        validation_name: 'NotEmpty',
                        diagnosis_name: 'OTHER_COMPLICATION_STOP_DT',
                    },
                    {
                        field: 'is_sae',
                        field_label_en: 'Reported as SAE?',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        diagnosis_name: 'IS_SAE',
                    },
                    {
                        field: 'is_er_second_visit',
                        field_label_en: 'Additional ER Visit',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        diagnosis_name: 'IS_ER_SECOND_VISIT',
                    },
                    {
                        field: 'is_er_second_visit_start_dt',
                        field_label_en: 'Additional ER Visit Start Date',
                        field_type: 'Date',
                        validation_name: 'NotEmpty',
                        diagnosis_name: 'IS_ER_SECOND_VISIT_START_DT',
                    },
                    {
                        field: 'is_er_second_visit_discharge_dt',
                        field_label_en: 'Additional ER Visit Discharge Date',
                        field_type: 'Date',
                        validation_name: 'NotEmpty',
                        diagnosis_name: 'IS_ER_SECOND_VISIT_DISCHARGE_DT',
                    },
                    {
                        field: 'is_hospitalization_second',
                        field_label_en: 'Additional Hospitalization',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        diagnosis_name: 'IS_HOSPITALIZATION_SECOND',
                    },
                    {
                        field: 'hospitalization_admission_second_dt',
                        field_label_en: 'Additional Hospitalization Admission Date',
                        field_type: 'Date',
                        validation_name: 'NotEmpty',
                        diagnosis_name: 'HOSPITALIZATION_ADMISSION_SECOND_DT',
                    },
                    {
                        field: 'hospitalization_discharge_second_dt',
                        field_label_en: 'Additional Hospitalization Discharge Date',
                        field_type: 'Date',
                        validation_name: 'NotEmpty',
                        diagnosis_name: 'HOSPITALIZATION_DISCHARGE_SECOND_DT',
                    },
                    {
                        field: 'lock_status',
                        field_label_en: 'Lock Status',
                        field_type: 'Boolean',
                        diagnosis_name: 'LOCK_STATUS',
                    },
                    {
                        field: 'lock_by',
                        field_label_en: 'Locked by',
                        field_type: 'Lookup',
                        related_table: 'Lookup_Names',
                    },
                    {
                        field: 'lock_dt',
                        field_label_en: 'Lock date',
                        field_type: 'DateTime',
                    },
                ],
            },
        ],
        Triggers: [
            {
                tableName: 'Table110131039',
                data: [
                    {
                        field: 'id',
                        field_label_en: 'Trigger ID',
                        field_type: 'ID',
                        detail_group: 'General',
                        export_name: 'ID',
                    },
                    {
                        field: 'trigger_name',
                        field_label_en: 'Name of Trigger',
                        field_type: 'Text',
                        detail_group: 'General',
                        export_name: 'TRIGGER_NAME',
                    },
                    {
                        field: 'title_en',
                        field_label_en: 'Display Title',
                        field_type: 'Text',
                        detail_group: 'General',
                        export_name: 'TITLE_EN',
                    },
                    {
                        field: 'subtitle_en',
                        field_label_en: 'Display Subtitle',
                        field_type: 'Text',
                        detail_group: 'General',
                        export_name: 'SUBTITLE_EN',
                    },
                    {
                        field: 'participant_id',
                        field_label_en: 'Participant ID',
                        field_type: 'Foreign Key',
                        detail_group: 'General',
                        related_table: 'Participant',
                        export_name: 'PARTICIPANT_ID',
                    },
                    {
                        field: 'trigger_page',
                        field_label_en: 'Trigger Page',
                        field_type: 'Text',
                        detail_group: 'General',
                        export_name: 'TRIGGER_PAGE',
                    },
                    {
                        field: 'trigger_dt',
                        field_label_en: 'Date to Execute the Trigger',
                        field_type: 'DateTime',
                        detail_group: 'General',
                        export_name: 'TRIGGER_DT',
                    },
                    {
                        field: 'trigger_count',
                        field_label_en: 'Number of Times to Execute',
                        field_type: 'Number',
                        detail_group: 'General',
                        export_name: 'TRIGGER_COUNT',
                    },
                    {
                        field: 'trigger_remain',
                        field_label_en: 'Number of Times Remaining',
                        field_type: 'Number',
                        detail_group: 'General',
                        export_name: 'TRIGGER_REMAIN',
                    },
                    {
                        field: 'trigger_delay',
                        field_label_en: 'Delay in Seconds Until Next Trigger',
                        field_type: 'Number',
                        detail_group: 'General',
                        export_name: 'TRIGGER_DELAY',
                    },
                    {
                        field: 'is_enabled',
                        field_label_en: 'Trigger Enabled',
                        field_type: 'Boolean',
                        detail_group: 'General',
                        export_name: 'IS_ENABLED',
                    },
                    {
                        field: 'trigger_status',
                        field_label_en: 'Trigger Status',
                        field_type: 'Lookup',
                        detail_group: 'Common Task Detail',
                        default_value: 'P',
                        options: 'Task_Status',
                        export_name: 'TRIGGER_STATUS',
                    },
                    {
                        field: 'created_dt',
                        field_label_en: 'Create Date',
                        field_type: 'DateTime',
                        detail_group: 'Tracking',
                        default_value: '{{now()}}',
                        export_name: 'CREATED_DT',
                    },
                    {
                        field: 'created_by',
                        field_label_en: 'Create User',
                        field_type: 'Foreign Key',
                        detail_group: 'Tracking',
                        related_table: 'PortalUser',
                        export_name: 'CREATED_BY',
                    },
                    {
                        field: 'executed_dt',
                        field_label_en: 'Close Date',
                        field_type: 'DateTime',
                        detail_group: 'Tracking',
                        export_name: 'EXECUTED_DT',
                    },
                    {
                        field: 'executed_by',
                        field_label_en: 'Close User',
                        field_type: 'Foreign Key',
                        detail_group: 'Tracking',
                        related_table: 'PortalUser',
                        export_name: 'EXECUTED_BY',
                    },
                ],
            },
        ],
        Tasks: [
            {
                tableName: 'Table1101310',
                data: [
                    {
                        field: 'id',
                        field_type: 'ID',
                        detail_group: 'General',
                        export_name: 'ID',
                    },
                    {
                        field: 'task_name',
                        field_label_en: 'Name of the Task',
                        field_type: 'Text',
                        detail_group: 'General',
                        export_name: 'TASK_NAME',
                    },
                    {
                        field: 'title_en',
                        field_label_en: 'Display Title',
                        field_type: 'Text',
                        detail_group: 'General',
                        export_name: 'TITLE_EN',
                    },
                    {
                        field: 'subtitle_en',
                        field_label_en: 'Display Subtitle',
                        field_type: 'Text',
                        detail_group: 'General',
                        export_name: 'SUBTITLE_EN',
                    },
                    {
                        field: 'participant_id',
                        field_label_en: 'Participant ID',
                        field_type: 'Foreign Key',
                        detail_group: 'General',
                        related_table: 'Participant',
                        export_name: 'PARTICIPANT_ID',
                    },
                    {
                        field: 'is_enabled',
                        field_label_en: 'Task Enabled',
                        field_type: 'Boolean',
                        detail_group: 'General',
                        export_name: 'IS_ENABLED',
                    },
                    {
                        field: 'hours_visible',
                        field_label_en: 'Hours Visible',
                        field_type: 'Number',
                        detail_group: 'Common Task Detail',
                        export_name: 'HOURS_VISIBLE',
                    },
                    {
                        field: 'is_blocking',
                        field_label_en: 'Is Blocking',
                        field_type: 'Boolean',
                        detail_group: 'Common Task Detail',
                        default_value: 'false',
                        export_name: 'IS_BLOCKING',
                    },
                    {
                        field: 'task_icon',
                        field_label_en: 'Task Icon',
                        field_type: 'Text',
                        detail_group: 'Common Task Detail',
                        default_value: 'IconTask.png',
                        export_name: 'TASK_ICON',
                    },
                    {
                        field: 'task_route',
                        field_label_en: 'Task Route',
                        field_type: 'Text',
                        export_name: 'TASK_ROUTE',
                    },
                    {
                        field: 'task_status',
                        field_label_en: 'Task Status',
                        field_type: 'Lookup',
                        detail_group: 'Common Task Detail',
                        default_value: 'P',
                        options: 'Task_Status',
                        export_name: 'TASK_STATUS',
                    },
                    {
                        field: 'created_dt',
                        field_label_en: 'Created Date',
                        field_type: 'DateTime',
                        detail_group: 'Tracking',
                        default_value: '{{now()}}',
                        export_name: 'CREATED_DT',
                    },
                    {
                        field: 'created_by',
                        field_label_en: 'Created User',
                        field_type: 'Foreign Key',
                        detail_group: 'Tracking',
                        related_table: 'PortalUser',
                        export_name: 'CREATED_BY',
                    },
                    {
                        field: 'closed_dt',
                        field_label_en: 'Closed Date',
                        field_type: 'DateTime',
                        export_name: 'CLOSED_DT',
                    },
                    {
                        field: 'closed_by',
                        field_label_en: 'Closed User',
                        field_type: 'Foreign Key',
                        detail_group: 'Tracking',
                        related_table: 'PortalUser',
                        export_name: 'CLOSED_BY',
                    },
                    {
                        field: 'closed_reason',
                        field_label_en: 'Closed Reason',
                        field_type: 'Lookup',
                        detail_group: 'Tracking',
                        options: 'task_close_reason',
                        export_name: 'CLOSED_REASON',
                    },
                ],
            },
        ],
        TaskCommon: [
            {
                tableName: 'Table11013',
                data: [
                    {
                        field: 'id',
                        field_type: 'ID',
                        detail_group: 'General',
                        export_name: 'ID',
                    },
                    {
                        field: 'participant_id',
                        field_label_en: 'Participant ID',
                        field_type: 'Foreign Key',
                        detail_group: 'General',
                        related_table: 'Participant',
                        export_name: 'PARTICIPANT_ID',
                    },
                    {
                        field: 'reported_dt',
                        field_label_en: 'Reported On',
                        field_type: 'DateTime',
                        validation_name: 'NotEmpty',
                        detail_group: 'Tracking',
                        export_name: 'REPORTED_DT',
                    },
                    {
                        field: 'reported_by',
                        field_label_en: 'Reported By',
                        field_type: 'Foreign Key',
                        validation_name: 'NotEmpty',
                        detail_group: 'Tracking',
                        related_table: 'PortalUser',
                        export_name: 'REPORTED_BY',
                    },
                    {
                        field: 'created_dt',
                        field_label_en: 'Created Date',
                        field_type: 'DateTime',
                        validation_name: 'NotEmpty',
                        detail_group: 'Tracking',
                        default_value: 'Now()',
                        export_name: 'CREATED_DT',
                    },
                    {
                        field: 'created_by',
                        field_label_en: 'Created By',
                        field_type: 'Foreign Key',
                        validation_name: 'NotEmpty',
                        detail_group: 'Tracking',
                        related_table: 'PortalUser',
                        export_name: 'CREATED_BY',
                    },
                    {
                        field: 'closed_dt',
                        field_label_en: 'Closed Date',
                        field_type: 'DateTime',
                        detail_group: 'Tracking',
                        export_name: 'CLOSED_DT',
                    },
                    {
                        field: 'closed_by',
                        field_label_en: 'Closed User',
                        field_type: 'Foreign Key',
                        detail_group: 'Tracking',
                        related_table: 'PortalUser',
                        export_name: 'CLOSED_BY',
                    },
                    {
                        field: 'closed_reason',
                        field_label_en: 'Closed Reason',
                        field_type: 'Lookup',
                        detail_group: 'Tracking',
                        options: 'task_close_reason',
                        export_name: 'CLOSED_REASON',
                    },
                    {
                        field: 'task_id',
                        field_label_en: 'Associated Task',
                        field_type: 'Foreign Key',
                        detail_group: 'Tracking',
                        related_table: 'Tasks',
                        export_name: 'TASK_ID',
                    },
                    {
                        field: 'task_title',
                        field_label_en: 'Title for this Task',
                        field_type: 'Text',
                        detail_group: 'Tracking',
                        related_table: 'Tasks',
                        export_name: 'TASK_TITLE',
                    },
                    {
                        field: 'lock_status',
                        field_label_en: 'Lock Status',
                        field_type: 'Boolean',
                        export_name: 'LOCK_STATUS',
                    },
                    {
                        field: 'lock_by',
                        field_label_en: 'Locked by',
                        field_type: 'Lookup',
                        detail_group: 'Lookup_Names',
                        export_name: 'LOCK_BY',
                    },
                    {
                        field: 'lock_dt',
                        field_label_en: 'Lock date',
                        field_type: 'DateTime',
                        export_name: 'LOCK_DT',
                    },
                ],
            },
        ],
        TaskInformedConsent: [
            {
                tableName: 'Table11016299',
                data: [
                    {
                        field: 'been_discussed',
                        field_label_en: 'Discussed with Subject',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        export_name: 'BEEN_DISCUSSED',
                    },
                    {
                        field: 'has_consented',
                        field_label_en: 'Confirm Consent for Study',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        export_name: 'HAS_CONSENTED',
                    },
                    {
                        field: 'has_consent_read',
                        field_label_en: 'Read and Discuss Consent',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        export_name: 'HAS_CONSENT_READ',
                    },
                    {
                        field: 'has_obtain_sign',
                        field_label_en: 'Obtain Signature on Consent',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        export_name: 'HAS_OBTAIN_SIGN',
                    },
                    {
                        field: 'has_provided_signcopy',
                        field_label_en: 'Provided Copy of Signed Consent',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        export_name: 'HAS_PROVIDED_SIGNCOPY',
                    },
                    {
                        field: 'expiration_dt',
                        field_label_en: 'Consent Expiration Date',
                        field_type: 'Date',
                        validation_name: 'NotEmpty',
                        export_name: 'EXPIRATION_DT',
                    },
                    {
                        field: 'hipaa_sign_dt',
                        field_label_en: 'HIPAA Form Signed Date',
                        field_type: 'Date',
                        validation_name: 'NotEmpty',
                        export_name: 'HIPAA_SIGN_DT',
                    },
                    {
                        field: 'consent_by',
                        field_label_en: 'Consent By',
                        field_type: 'Lookup',
                        validation_name: 'NotEmpty',
                        options: 'Lookup_Names',
                        export_name: 'CONSENT_BY',
                    },
                    {
                        field: 'consent_dt',
                        field_label_en: 'Consent Date',
                        field_type: 'Date',
                        validation_name: 'NotEmpty',
                        export_name: 'CONSENT_DT',
                    },
                ],
            },
        ],
        TaskDemographics: [
            {
                tableName: 'Table1101629',
                data: [
                    {
                        field: 'sex',
                        field_label_en: 'Sex at Birth',
                        field_type: 'Lookup',
                        validation_name: 'NotEmpty',
                        detail_group: 'Demographics',
                        options: 'Sex',
                        min_count: '1',
                        max_count: '1',
                        blinded: 'Yes',
                        pii: 'Yes',
                        export_name: 'SEX',
                    },
                    {
                        field: 'race',
                        field_label_en: 'Race',
                        field_type: 'Lookup',
                        validation_name: 'NotEmpty',
                        detail_group: 'Other Characteristics',
                        options: 'Race',
                        min_count: '1',
                        max_count: '7',
                        export_name: 'RACE',
                    },
                    {
                        field: 'race_specify',
                        field_label_en: 'Other (specify)',
                        field_type: 'Text',
                        validation_name: 'NotEmpty',
                        detail_group: 'Other Characteristics',
                        export_name: 'RACE_SPECIFY',
                    },
                    {
                        field: 'ethnicity',
                        field_label_en: 'Ethnicity',
                        field_type: 'Lookup',
                        validation_name: 'NotEmpty',
                        detail_group: 'Other Characteristics',
                        options: 'Ethnicity',
                        export_name: 'ETHNICITY',
                    },
                ],
            },
        ],
        TaskInclusionExclusionCheck: [
            {
                tableName: 'Table110161724',
                data: [
                    {
                        field: 'age_check',
                        field_label_en: 'Age ≥55 check',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        detail_group: 'Task Detail',
                        export_name: 'AGE_CHECK',
                    },
                    {
                        field: 'can_eatdrink',
                        field_label_en: 'Able to Eat and Drink',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        detail_group: 'Task Detail',
                        export_name: 'CAN_EATDRINK',
                    },
                    {
                        field: 'ready_for_clcstay',
                        field_label_en: 'Ready for CLC During Study',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        detail_group: 'Task Detail',
                        export_name: 'READY_FOR_CLCSTAY',
                    },
                    {
                        field: 'consent_obtained',
                        field_label_en: 'Signed Consent Obtained',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        detail_group: 'Task Detail',
                        export_name: 'CONSENT_OBTAINED',
                    },
                    {
                        field: 'authorization_obtained',
                        field_label_en: 'An Authorization Obtained',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        detail_group: 'Task Detail',
                        export_name: 'AUTHORIZATION_OBTAINED',
                    },
                    {
                        field: 'periodically_blood_samples',
                        field_label_en: 'Periodically Gives Blood Samples',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        detail_group: 'Task Detail',
                        export_name: 'PERIODICALLY_BLOOD_SAMPLES',
                    },
                    {
                        field: 'signed_written_consent',
                        field_label_en: 'Signed and Written Informed Consent',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        detail_group: 'Task Detail',
                        export_name: 'SIGNED_WRITTEN_CONSENT',
                    },
                    {
                        field: 'receiving_parenteral_nutrition',
                        field_label_en: 'Receiving Parenteral Nutrition',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        detail_group: 'Task Detail',
                        export_name: 'RECEIVING_PARENTERAL_NUTRITION',
                    },
                    {
                        field: 'has_known_eating_disorder',
                        field_label_en: 'Known Eating Disorder or Illness',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        detail_group: 'Task Detail',
                        export_name: 'HAS_KNOWN_EATING_DISORDER',
                    },
                    {
                        field: 'is_immunocompromised',
                        field_label_en: 'Diagnosed as Immunocompromised',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        detail_group: 'Task Detail',
                        export_name: 'IS_IMMUNOCOMPROMISED',
                    },
                    {
                        field: 'has_known_allergy',
                        field_label_en: 'Known Allergy',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        detail_group: 'Task Detail',
                        export_name: 'HAS_KNOWN_ALLERGY',
                    },
                    {
                        field: 'critical_life_expectancy',
                        field_label_en: 'Expected to Live',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        detail_group: 'Task Detail',
                        export_name: 'CRITICAL_LIFE_EXPECTANCY',
                    },
                    {
                        field: 'is_inappropriate_for_inclusion',
                        field_label_en: 'Inappropriate for Inclusion',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        detail_group: 'Task Detail',
                        export_name: 'IS_INAPPROPRIATE_FOR_INCLUSION',
                    },
                    {
                        field: 'is_unable_unwilling',
                        field_label_en: 'Unable or Unwilling to Comply',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        detail_group: 'Task Detail',
                        export_name: 'IS_UNABLE_UNWILLING',
                    },
                    {
                        field: 'has_rti',
                        field_label_en: 'RTI Within 1 Week Prior to Randomization',
                        field_type: 'Lookup',
                        validation_name: 'NotEmpty',
                        detail_group: 'Task Detail',
                        options: 'Rti_Confirmed',
                        export_name: 'HAS_RTI',
                    },
                    {
                        field: 'rti_assessed_dt',
                        field_label_en: 'RTI Assessment Date',
                        field_type: 'Date',
                        validation_name: 'NotEmpty',
                        detail_group: 'Task Detail',
                        export_name: 'RTI_ASSESSED_DT',
                    },
                    {
                        field: 'consent_dt',
                        field_label_en: 'Consent date',
                        field_type: 'Date',
                        validation_name: 'NotEmpty',
                        detail_group: 'Task Detail',
                        export_name: 'CONSENT_DT',
                    },
                    {
                        field: 'meet_criteria',
                        field_label_en: 'Meet all INCLUSION/EXCLUSION Criteria',
                        field_type: 'Boolean',
                        detail_group: 'Task Detail',
                        export_name: 'MEET_CRITERIA',
                    },
                ],
            },
        ],
        TaskSmokingStatus: [
            {
                tableName: 'Table11016298',
                data: [
                    {
                        field: 'have_used_tobacco',
                        field_label_en: 'Have You Ever Used Tobacco Products on a Routine Basis?',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        detail_group: 'Other Characteristics',
                        export_name: 'HAVE_USED_TOBACCO',
                    },
                    {
                        field: 'routine_frequency',
                        field_label_en: 'Routine Frequency',
                        field_type: 'Lookup',
                        validation_name: 'NotEmpty',
                        detail_group: 'Other Characteristics',
                        options: 'tobacco_frequency',
                        export_name: 'ROUTINE_FREQUENCY',
                    },
                    {
                        field: 'routine_quantity',
                        field_label_en: 'Routine Quantity',
                        field_type: 'Lookup',
                        validation_name: 'NotEmpty',
                        detail_group: 'Other Characteristics',
                        options: 'tobacco_quantity',
                        export_name: 'ROUTINE_QUANTITY',
                    },
                    {
                        field: 'tobacco_status',
                        field_label_en: 'Tobacco Products Use',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        detail_group: 'Other Characteristics',
                        export_name: 'TOBACCO_STATUS',
                    },
                    {
                        field: 'current_frequency',
                        field_label_en: 'Current Frequency',
                        field_type: 'Lookup',
                        validation_name: 'NotEmpty',
                        detail_group: 'Other Characteristics',
                        options: 'tobacco_frequency',
                        export_name: 'CURRENT_FREQUENCY',
                    },
                ],
            },
        ],
        TaskBodyMeasurements: [
            {
                tableName: 'Table110161721222325',
                data: [
                    {
                        field: 'body_weight',
                        field_label_en: 'Body Weight',
                        field_type: 'MeasureWeight',
                        validation_name: 'NotEmpty',
                        detail_group: 'TaskDetail',
                        export_name: 'BODY_WEIGHT',
                    },
                    {
                        field: 'weight_collection_dt',
                        field_label_en: 'Weight Collection Date',
                        field_type: 'Date',
                        validation_name: 'NotEmpty',
                        detail_group: 'TaskDetail',
                        export_name: 'WEIGHT_COLLECTION_DT',
                    },
                    {
                        field: 'height',
                        field_label_en: 'Height',
                        field_type: 'MeasurePhysical',
                        validation_name: 'NotEmpty',
                        detail_group: 'TaskDetail',
                        export_name: 'HEIGHT',
                    },
                    {
                        field: 'height_collection_dt',
                        field_label_en: 'Height Collection Date',
                        field_type: 'Date',
                        validation_name: 'NotEmpty',
                        detail_group: 'TaskDetail',
                        export_name: 'HEIGHT_COLLECTION_DT',
                    },
                    {
                        field: 'bmi',
                        field_label_en: 'BMI',
                        field_type: 'Number',
                        validation_name: 'Calculation',
                        detail_group: 'Body_Measurements',
                        options: '{{703*(body_weight/(height*height))}}',
                    },
                ],
            },
        ],
        TaskSf12: [
            {
                tableName: 'Table1101618',
                data: [
                    {
                        field: 'health_status',
                        field_label_en: 'Health Status',
                        field_type: 'Lookup',
                        validation_name: 'NotEmpty',
                        detail_group: 'Task Detail',
                        options: 'QOL_HealthStatus',
                        min_count: '1',
                        max_count: '1',
                        export_name: 'HEALTH_STATUS',
                    },
                    {
                        field: 'mobility',
                        field_label_en: 'Moderate Activities',
                        field_type: 'Lookup',
                        validation_name: 'NotEmpty',
                        display_level: 'Detail',
                        detail_group: 'Task Detail',
                        options: 'QOL_Mobility',
                        min_count: '1',
                        max_count: '1',
                        export_name: 'MOBILITY',
                    },
                    {
                        field: 'climbing',
                        field_label_en: 'Can Climb Several Flights of Stairs',
                        field_type: 'Lookup',
                        validation_name: 'NotEmpty',
                        display_level: 'Detail',
                        detail_group: 'Task Detail',
                        options: 'QOL_Climbing',
                        min_count: '1',
                        max_count: '1',
                        export_name: 'CLIMBING',
                    },
                    {
                        field: 'lackphysical',
                        field_label_en: 'Lack of Physical',
                        field_type: 'Lookup',
                        validation_name: 'NotEmpty',
                        display_level: 'Detail',
                        detail_group: 'Task Detail',
                        options: 'QOL_Timepoints',
                        min_count: '1',
                        max_count: '1',
                        export_name: 'LACKPHYSICAL',
                    },
                    {
                        field: 'physical_ltdact',
                        field_label_en: 'Limited Physical Activities',
                        field_type: 'Lookup',
                        validation_name: 'NotEmpty',
                        display_level: 'Detail',
                        detail_group: 'Task Detail',
                        options: 'QOL_Timepoints',
                        min_count: '1',
                        max_count: '1',
                        export_name: 'PHYSICAL_LTDACT',
                    },
                    {
                        field: 'emo_acmplish',
                        field_label_en: 'Emotional Accomplishment',
                        field_type: 'Lookup',
                        validation_name: 'NotEmpty',
                        display_level: 'Detail',
                        detail_group: 'Task Detail',
                        options: 'QOL_Timepoints',
                        min_count: '1',
                        max_count: '1',
                        export_name: 'EMO_ACMPLISH',
                    },
                    {
                        field: 'lack_of_care',
                        field_label_en: 'Lack of Care',
                        field_type: 'Lookup',
                        validation_name: 'NotEmpty',
                        detail_group: 'Task Detail',
                        options: 'QOL_Timepoints',
                        min_count: '1',
                        max_count: '1',
                        export_name: 'LACK_OF_CARE',
                    },
                    {
                        field: 'pain_interference',
                        field_label_en: 'Pain Interference',
                        field_type: 'Lookup',
                        validation_name: 'NotEmpty',
                        detail_group: 'Task Detail',
                        options: 'QOL_Interference',
                        min_count: '1',
                        max_count: '1',
                        export_name: 'PAIN_INTERFERENCE',
                    },
                    {
                        field: 'felt_peaceful',
                        field_label_en: 'Felt Calm and Peaceful',
                        field_type: 'Lookup',
                        validation_name: 'NotEmpty',
                        detail_group: 'Task Detail',
                        options: 'QOL_Timepoints',
                        min_count: '1',
                        max_count: '1',
                        export_name: 'FELT_PEACEFUL',
                    },
                    {
                        field: 'felt_energetic',
                        field_label_en: 'Felt Energetic',
                        field_type: 'Lookup',
                        validation_name: 'NotEmpty',
                        detail_group: 'Task Detail',
                        options: 'QOL_Timepoints',
                        min_count: '1',
                        max_count: '1',
                        export_name: 'FELT_ENERGETIC',
                    },
                    {
                        field: 'felt_depressed',
                        field_label_en: 'Depressed and Downhearted',
                        field_type: 'Lookup',
                        validation_name: 'NotEmpty',
                        detail_group: 'Task Detail',
                        options: 'QOL_Timepoints',
                        min_count: '1',
                        max_count: '1',
                        export_name: 'FELT_DEPRESSED',
                    },
                    {
                        field: 'social_interference',
                        field_label_en: 'Social Interference',
                        field_type: 'Lookup',
                        validation_name: 'NotEmpty',
                        detail_group: 'Task Detail',
                        options: 'QOL_Timepoints',
                        min_count: '1',
                        max_count: '1',
                        export_name: 'SOCIAL_INTERFERENCE',
                    },
                    {
                        field: 'assessment_dt',
                        field_label_en: 'Date of Assessment',
                        field_type: 'Date',
                        validation_name: 'NotEmpty',
                        detail_group: 'Task Detail',
                        export_name: 'ASSESSMENT_DT',
                    },
                ],
            },
        ],
        TaskBloodNeeded: [
            {
                tableName: 'Table11016176',
                data: [
                    {
                        field: 'was_blood_collected',
                        field_label_en: 'Was Sample Collected',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        detail_group: 'Task Detail',
                        export_name: 'WAS_BLOOD_COLLECTED',
                    },
                    {
                        field: 'no_reason',
                        field_label_en: 'If No, provide reason',
                        field_type: 'Text',
                        validation_name: 'NotEmpty',
                        detail_group: 'Task Detail',
                        export_name: 'NO_REASON',
                    },
                    {
                        field: 'reason',
                        field_label_en: 'Reason for Collection',
                        field_type: 'Text',
                        detail_group: 'Task Detail',
                        export_name: 'REASON',
                    },
                ],
            },
        ],
        TaskBaselineCbc: [
            {
                tableName: 'Table1101617',
                data: [
                    {
                        field: 'blood_collection_dt',
                        field_label_en: 'Blood Sample Collection Date',
                        field_type: 'Date',
                        validation_name: 'NotEmpty',
                        export_name: 'BLOOD_COLLECTION_DT',
                    },
                    {
                        field: 'blood_collection_time',
                        field_label_en: 'Blood Sample Collection Time',
                        field_type: 'Time',
                        validation_name: 'NotEmpty',
                        export_name: 'BLOOD_COLLECTION_TIME',
                    },
                    {
                        field: 'wbc',
                        field_label_en: 'WBC',
                        field_type: 'DecimalThousandPerMicroLiter',
                        validation_name: 'NotEmpty',
                        export_name: 'WBC',
                    },
                    {
                        field: 'rbc',
                        field_label_en: 'RBC',
                        field_type: 'DecimalMillionPerMicroLiter',
                        validation_name: 'NotEmpty',
                        export_name: 'RBC',
                    },
                    {
                        field: 'hgb',
                        field_label_en: 'HgB',
                        field_type: 'DecimalGramsPerDeciliter',
                        validation_name: 'NotEmpty',
                        export_name: 'HGB',
                    },
                    {
                        field: 'hct',
                        field_label_en: 'Hct',
                        field_type: 'Percent',
                        validation_name: 'NotEmpty',
                        min_count: '0',
                        max_count: '100',
                        export_name: 'HCT',
                    },
                    {
                        field: 'mcv',
                        field_label_en: 'MCV',
                        field_type: 'DecimalOneCubicMicroMeter',
                        validation_name: 'NotEmpty',
                        export_name: 'MCV',
                    },
                    {
                        field: 'mch',
                        field_label_en: 'MCH',
                        field_type: 'DecimalPicograms',
                        validation_name: 'NotEmpty',
                        export_name: 'MCH',
                    },
                    {
                        field: 'mchc',
                        field_label_en: 'MCHC',
                        field_type: 'DecimalGramsPerDeciliter',
                        validation_name: 'NotEmpty',
                        export_name: 'MCHC',
                    },
                    {
                        field: 'rdw',
                        field_label_en: 'RDW',
                        field_type: 'DecimalOneCubicMicroMeter',
                        validation_name: 'NotEmpty',
                        export_name: 'RDW',
                    },
                    {
                        field: 'platelets',
                        field_label_en: 'Platelets',
                        field_type: 'DecimalThousandPerMicroLiter',
                        validation_name: 'NotEmpty',
                        export_name: 'PLATELETS',
                    },
                    {
                        field: 'neutrophils_percent',
                        field_label_en: 'Neutrophils %',
                        field_type: 'Percent',
                        validation_name: 'NotEmpty',
                        min_count: '0',
                        max_count: '100',
                        export_name: 'NEUTROPHILS_PERCENT',
                    },
                    {
                        field: 'lymphocytes_percent',
                        field_label_en: 'Lymphocytes %',
                        field_type: 'Percent',
                        validation_name: 'NotEmpty',
                        min_count: '0',
                        max_count: '100',
                        export_name: 'LYMPHOCYTES_PERCENT',
                    },
                    {
                        field: 'monocytes_percent',
                        field_label_en: 'Monocytes %',
                        field_type: 'Percent',
                        validation_name: 'NotEmpty',
                        min_count: '0',
                        max_count: '100',
                        export_name: 'MONOCYTES_PERCENT',
                    },
                    {
                        field: 'eosinophils_percent',
                        field_label_en: 'Eosinophils %',
                        field_type: 'Percent',
                        validation_name: 'NotEmpty',
                        min_count: '0',
                        max_count: '100',
                        export_name: 'EOSINOPHILS_PERCENT',
                    },
                    {
                        field: 'basophils_percent',
                        field_label_en: 'Basophils %',
                        field_type: 'Percent',
                        validation_name: 'NotEmpty',
                        min_count: '0',
                        max_count: '100',
                        export_name: 'BASOPHILS_PERCENT',
                    },
                    {
                        field: 'ig_percent',
                        field_label_en: 'IG %',
                        field_type: 'Percent',
                        validation_name: 'NotEmpty',
                        min_count: '0',
                        max_count: '100',
                        export_name: 'IG_PERCENT',
                    },
                    {
                        field: 'nrbc_percent',
                        field_label_en: 'NRBC  %',
                        field_type: 'Percent',
                        validation_name: 'NotEmpty',
                        min_count: '0',
                        max_count: '100',
                        export_name: 'NRBC_PERCENT',
                    },
                    {
                        field: 'neutrophils',
                        field_label_en: 'Neutrophils #',
                        field_type: 'DecimalMicroLiter',
                        validation_name: 'NotEmpty',
                        export_name: 'NEUTROPHILS',
                    },
                    {
                        field: 'lymphocytes',
                        field_label_en: 'Lymphocytes #',
                        field_type: 'DecimalMicroLiter',
                        validation_name: 'NotEmpty',
                        export_name: 'LYMPHOCYTES',
                    },
                    {
                        field: 'monocytes',
                        field_label_en: 'Monocytes #',
                        field_type: 'DecimalMicroLiter',
                        validation_name: 'NotEmpty',
                        export_name: 'MONOCYTES',
                    },
                    {
                        field: 'eosinophils',
                        field_label_en: 'Eosinophils #',
                        field_type: 'DecimalMicroLiter',
                        validation_name: 'NotEmpty',
                        export_name: 'EOSINOPHILS',
                    },
                    {
                        field: 'basophils',
                        field_label_en: 'Basophils #',
                        field_type: 'DecimalMicroLiter',
                        validation_name: 'NotEmpty',
                        export_name: 'BASOPHILS',
                    },
                    {
                        field: 'ig',
                        field_label_en: 'IG #',
                        field_type: 'DecimalMicroLiter',
                        validation_name: 'NotEmpty',
                        export_name: 'IG',
                    },
                    {
                        field: 'nrbc',
                        field_label_en: 'NRBC #',
                        field_type: 'DecimalMicroLiter',
                        validation_name: 'NotEmpty',
                        export_name: 'NRBC',
                    },
                ],
            },
        ],
        TaskMetabolicPanel: [
            {
                tableName: 'Table110161721',
                data: [
                    {
                        field: 'blood_collection_dt',
                        field_label_en: 'Blood Sample Collection Date',
                        field_type: 'Date',
                        validation_name: 'NotEmpty',
                        detail_group: 'Task Detail',
                        export_name: 'BLOOD_COLLECTION_DT',
                    },
                    {
                        field: 'blood_collection_time',
                        field_label_en: 'Blood Sample Collection Time',
                        field_type: 'Time',
                        validation_name: 'NotEmpty',
                        detail_group: 'Task Detail',
                        export_name: 'BLOOD_COLLECTION_TIME',
                    },
                    {
                        field: 'sodium',
                        field_label_en: 'Sodium',
                        field_type: 'DecimalMillimolesPerLitre',
                        validation_name: 'NotEmpty',
                        detail_group: 'Task Detail',
                        export_name: 'SODIUM',
                    },
                    {
                        field: 'potassium',
                        field_label_en: 'Potassium',
                        field_type: 'DecimalMillimolesPerLitre',
                        validation_name: 'NotEmpty',
                        detail_group: 'Task Detail',
                        export_name: 'POTASSIUM',
                    },
                    {
                        field: 'chloride',
                        field_label_en: 'Chloride',
                        field_type: 'DecimalMillimolesPerLitre',
                        validation_name: 'NotEmpty',
                        detail_group: 'Task Detail',
                        export_name: 'CHLORIDE',
                    },
                    {
                        field: 'co2',
                        field_label_en: 'CO2',
                        field_type: 'DecimalMillimolesPerLitre',
                        validation_name: 'NotEmpty',
                        detail_group: 'Task Detail',
                        export_name: 'CO2',
                    },
                    {
                        field: 'urea_nitrogen',
                        field_label_en: 'Urea Nitrogen',
                        field_type: 'DecimalMilligramsPerDeciliter',
                        validation_name: 'NotEmpty',
                        detail_group: 'Task Detail',
                        export_name: 'UREA_NITROGEN',
                    },
                    {
                        field: 'creatinine',
                        field_label_en: 'Creatinine idms',
                        field_type: 'DecimalMilligramsPerDeciliter',
                        validation_name: 'NotEmpty',
                        detail_group: 'Task Detail',
                        export_name: 'CREATININE',
                    },
                    {
                        field: 'egfr',
                        field_label_en: 'EGFR',
                        field_type: 'DecimalMillimetersMinuteMeterSq',
                        validation_name: 'NotEmpty',
                        detail_group: 'Task Detail',
                        edit_group: 'EGFR',
                        export_name: 'EGFR',
                    },
                    {
                        field: 'glucose',
                        field_label_en: 'Glucose',
                        field_type: 'DecimalMilligramsPerDeciliter',
                        validation_name: 'NotEmpty',
                        detail_group: 'Task Detail',
                        export_name: 'GLUCOSE',
                    },
                    {
                        field: 'calcium',
                        field_label_en: 'Calcium',
                        field_type: 'DecimalMilligramsPerDeciliter',
                        validation_name: 'NotEmpty',
                        detail_group: 'Task Detail',
                        export_name: 'CALCIUM',
                    },
                    {
                        field: 'magnesium',
                        field_label_en: 'Magnesium',
                        field_type: 'DecimalMilligramsPerDeciliter',
                        validation_name: 'NotEmpty',
                        detail_group: 'Task Detail',
                        edit_group: 'MAGNESIUM',
                        export_name: 'MAGNESIUM',
                    },
                    {
                        field: 'phosphorus',
                        field_label_en: 'Phosphorus',
                        field_type: 'DecimalMilligramsPerDeciliter',
                        validation_name: 'NotEmpty',
                        detail_group: 'Task Detail',
                        edit_group: 'PHOSPHORUS',
                        export_name: 'PHOSPHORUS',
                    },
                    {
                        field: 'alkaline_phosphatase',
                        field_label_en: 'Alkaline Phosphatase',
                        field_type: 'DecimalUnitPerLiter',
                        validation_name: 'NotEmpty',
                        detail_group: 'Task Detail',
                        export_name: 'ALKALINE_PHOSPHATASE',
                    },
                    {
                        field: 'alanine_aminotransferase',
                        field_label_en: 'Alanine Aminotransferase',
                        field_type: 'DecimalUnitPerLiter',
                        validation_name: 'NotEmpty',
                        detail_group: 'Task Detail',
                        edit_group: 'ALANINE_AMINOTRANSFERASE',
                        export_name: 'ALANINE_AMINOTRANSFERASE',
                    },
                    {
                        field: 'bilirubin',
                        field_label_en: 'Total Bilirubin',
                        field_type: 'DecimalMilligramsPerDeciliter',
                        validation_name: 'NotEmpty',
                        detail_group: 'Task Detail',
                        export_name: 'BILIRUBIN',
                    },
                    {
                        field: 'albumin',
                        field_label_en: 'Albumin',
                        field_type: 'DecimalGramsPerDeciliter',
                        validation_name: 'NotEmpty',
                        detail_group: 'Task Detail',
                        export_name: 'ALBUMIN',
                    },
                    {
                        field: 'is_recollect',
                        field_label_en: 'Recollect Requested',
                        field_type: 'Boolean',
                        detail_group: 'Task Detail',
                        export_name: 'IS_RECOLLECT',
                    },
                    {
                        field: 'recollect_form_id',
                        field_label_en: 'ID of the Recollect Form',
                        field_type: 'Text',
                        detail_group: 'Task Detail',
                        export_name: 'RECOLLECT_FORM_ID',
                    },
                ],
            },
        ],
        TaskInfluenzaVaccinePanel: [
            {
                tableName: 'Table1101617212223',
                data: [
                    {
                        field: 'influenza_booster_dt',
                        field_label_en: 'Date of Influenza Booster',
                        field_type: 'Date',
                        validation_name: 'NotEmpty',
                        detail_group: 'TaskDetail',
                        options: 'MM/DD/YYYY',
                        export_name: 'INFLUENZA_BOOSTER_DT',
                    },
                    {
                        field: 'sample_collection_timepoint',
                        field_label_en: 'Sample Collection Timepoint',
                        field_type: 'Lookup',
                        validation_name: 'NotEmpty',
                        detail_group: 'TaskDetail',
                        options: 'collection_timepoints',
                        export_name: 'SAMPLE_COLLECTION_TIMEPOINT',
                    },
                    {
                        field: 'blood_sampling_dt',
                        field_label_en: 'Date of Vaccine Specific Blood Sampling',
                        field_type: 'Date',
                        validation_name: 'NotEmpty',
                        detail_group: 'TaskDetail',
                        export_name: 'BLOOD_SAMPLING_DT',
                    },
                    {
                        field: 'blood_sampling_time',
                        field_label_en: 'Time of Collection',
                        field_type: 'Time',
                        validation_name: 'NotEmpty',
                        detail_group: 'TaskDetail',
                        export_name: 'BLOOD_SAMPLING_TIME',
                    },
                ],
            },
        ],
        TaskSalivaNeeded: [
            {
                tableName: 'Table1101617212736',
                data: [
                    {
                        field: 'was_saliva_collected',
                        field_label_en: 'Sample Collected',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        detail_group: 'Task Detail',
                        export_name: 'WAS_SALIVA_COLLECTED',
                    },
                    {
                        field: 'no_reason',
                        field_label_en: 'If No, provide reason',
                        field_type: 'Text',
                        validation_name: 'NotEmpty',
                        detail_group: 'Task Detail',
                        export_name: 'NO_REASON',
                    },
                    {
                        field: 'reason',
                        field_label_en: 'Reason for Collection',
                        field_type: 'Text',
                        validation_name: 'NotEmpty',
                        detail_group: 'Task Detail',
                        related_table: 'Screening Visit 1',
                        export_name: 'REASON',
                    },
                ],
            },
        ],
        TaskSalivaMarkers: [
            {
                tableName: 'Table11016172127',
                data: [
                    {
                        field: 'saliva_collection_dt',
                        field_label_en: 'Saliva Sample Collection Date',
                        field_type: 'Date',
                        validation_name: 'NotEmpty',
                        detail_group: 'Task Detail',
                        export_name: 'SALIVA_COLLECTION_DT',
                    },
                    {
                        field: 'saliva_collection_time',
                        field_label_en: 'Saliva Sample Collection Time',
                        field_type: 'Time',
                        validation_name: 'NotEmpty',
                        detail_group: 'Task Detail',
                        export_name: 'SALIVA_COLLECTION_TIME',
                    },
                    {
                        field: 'lactoferrin',
                        field_label_en: 'Lactoferrin (human)',
                        field_type: 'DecimalMicrogramsPerMilliliter',
                        validation_name: 'NotEmpty',
                        detail_group: 'Task Detail',
                        export_name: 'LACTOFERRIN',
                    },
                    {
                        field: 'thiocyanate',
                        field_label_en: 'Thiocyanate (SCN-)',
                        field_type: 'DecimalMicromolar',
                        validation_name: 'NotEmpty',
                        detail_group: 'Task Detail',
                        export_name: 'THIOCYANATE',
                    },
                    {
                        field: 'hypohalous_acids',
                        field_label_en: 'Hypothiocyanous acid (HOSCN)',
                        field_type: 'DecimalMicromolar',
                        validation_name: 'NotEmpty',
                        detail_group: 'Task Detail',
                        export_name: 'HYPOHALOUS_ACIDS',
                    },
                    {
                        field: 'iodide',
                        field_label_en: 'Iodide (I-)',
                        field_type: 'DecimalMicromolar',
                        validation_name: 'NotEmpty',
                        detail_group: 'Task Detail',
                        export_name: 'IODIDE',
                    },
                    {
                        field: 'hypoiodous_acid',
                        field_label_en: 'Hypoiodous acid (HOI)',
                        field_type: 'DecimalMicromolar',
                        validation_name: 'NotEmpty',
                        detail_group: 'Task Detail',
                        export_name: 'HYPOIODOUS_ACID',
                    },
                ],
            },
        ],
        Sheet1: [],
        'TaskInfluenzaInflammatoryPanel ': [
            {
                tableName: 'Table110161721222340',
                data: [
                    {
                        field: 'crp',
                        field_label_en: 'CRP',
                        field_type: 'DecimalMicrogramsPerMilliliter',
                        validation_name: 'NotEmpty',
                        detail_group: 'TaskDetail',
                        export_name: 'CRP',
                    },
                    {
                        field: 'il_6',
                        field_label_en: 'IL-6',
                        field_type: 'DecimalPicogramsPerMilliliter',
                        validation_name: 'NotEmpty',
                        detail_group: 'TaskDetail',
                        export_name: 'IL_6',
                    },
                    {
                        field: 'il_8',
                        field_label_en: 'IL-8',
                        field_type: 'DecimalPicogramsPerMilliliter',
                        validation_name: 'NotEmpty',
                        detail_group: 'TaskDetail',
                    },
                    {
                        field: 'serum_amyloid_a',
                        field_label_en: 'Serum Amyloid A',
                        field_type: 'DecimalMicrogramsPerMilliliter',
                        validation_name: 'NotEmpty',
                        detail_group: 'TaskDetail',
                        export_name: 'SERUM_AMYLOID_A',
                    },
                    {
                        field: 'tnf_alpha',
                        field_label_en: 'TNF-alpha',
                        field_type: 'DecimalPicogramsPerMilliliter',
                        validation_name: 'NotEmpty',
                        detail_group: 'TaskDetail',
                        export_name: 'TNF_ALPHA',
                    },
                    {
                        field: 'ifn_gamma',
                        field_label_en: 'IFN-Gamma',
                        field_type: 'DecimalMicrogramsPerMilliliter',
                        validation_name: 'NotEmpty',
                        detail_group: 'TaskDetail',
                        export_name: 'IFN_GAMMA',
                    },
                    {
                        field: 'mif',
                        field_label_en: 'MIF',
                        field_type: 'DecimalMicrogramsPerMilliliter',
                        validation_name: 'NotEmpty',
                        detail_group: 'TaskDetail',
                        export_name: 'MIF',
                    },
                    {
                        field: 'hai',
                        field_label_en: 'HAI',
                        field_type: 'DecimalMicrogramsPerMilliliter',
                        validation_name: 'NotEmpty',
                        detail_group: 'TaskDetail',
                        export_name: '23',
                    },
                ],
            },
        ],
        TaskCovidInitialDose: [
            {
                tableName: 'Table110161721222330',
                data: [
                    {
                        field: 'was_vaccine_given',
                        field_label_en: 'Vaccine given or not',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        detail_group: 'Taskdetail',
                        export_name: 'WAS_VACCINE_GIVEN',
                    },
                    {
                        field: 'dose_type',
                        field_label_en: 'Initial Vaccination or Booster',
                        field_type: 'Text',
                        detail_group: 'Taskdetail',
                        export_name: 'DOSE_TYPE',
                    },
                    {
                        field: 'collection_timepoint',
                        field_label_en: 'Sample collection time-points',
                        field_type: 'Text',
                        detail_group: 'TaskDetail',
                        export_name: 'COLLECTION_TIMEPOINT',
                    },
                    {
                        field: 'vaccine_given_dt',
                        field_label_en: 'Vaccine given date',
                        field_type: 'Date',
                        validation_name: 'NotEmpty',
                        detail_group: 'TaskDetail',
                        export_name: 'VACCINE_GIVEN_DT',
                    },
                    {
                        field_label_en: 'No Vaccine Reason',
                        field_type: 'Text',
                        validation_name: 'NotEmpty',
                        detail_group: 'TaskDetail',
                    },
                ],
            },
        ],
        TaskCovidBloodNeeded: [
            {
                tableName: 'Table11016172122233010',
                data: [
                    {
                        field: 'was_blood_collected',
                        field_label_en: 'Vaccine specific blood given or not',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        detail_group: 'Taskdetail',
                        export_name: 'WAS_BLOOD_COLLECTED',
                    },
                    {
                        field: 'no_reason',
                        field_label_en: 'No reason',
                        field_type: 'Text',
                        validation_name: 'NotEmpty',
                        detail_group: 'TaskDetail',
                        export_name: 'NO_REASON',
                    },
                ],
            },
        ],
        TaskCovidBloodResult: [
            {
                tableName: 'Table1101617212223301044',
                data: [
                    {
                        field: 'blood_sampling_collection_dt',
                        field_label_en: 'Vaccine specific blood sampling date',
                        field_type: 'Date',
                        validation_name: 'NotEmpty',
                        detail_group: 'TaskDetail',
                        options: 'MM/DD/YYYY',
                        export_name: 'BLOOD_SAMPLING_COLLECTION_DT',
                    },
                    {
                        field: 'blood_sampling_collection_time',
                        field_label_en: 'Time of collection',
                        field_type: 'Time',
                        validation_name: 'NotEmpty',
                        detail_group: 'TaskDetail',
                        export_name: 'BLOOD_SAMPLING_COLLECTION_TIME',
                    },
                    {
                        field: 'gmt_of_rbd',
                        field_label_en:
                            'Geometric Mean Titer (GMT) of RBD-binding IgG concentrations',
                        field_type: 'DecimalGeometricMeanTiter',
                        validation_name: 'NotEmpty',
                        detail_group: 'TaskDetail',
                        export_name: 'GMT_OF_RBD',
                    },
                    {
                        field: 'pbmc',
                        field_label_en: 'PBMC cytokine profile',
                        field_type: 'DecimalKCellsPerMicroLiter',
                        validation_name: 'NotEmpty',
                        detail_group: 'TaskDetail',
                        export_name: 'PBMC',
                    },
                    {
                        field: 'tnf',
                        field_label_en: 'TNF-α',
                        field_type: 'DecimalPicogramsPerMilliliter',
                        validation_name: 'NotEmpty',
                        detail_group: 'TaskDetail',
                        export_name: 'TNF',
                    },
                    {
                        field: 'ifn',
                        field_label_en: 'IFN-γ',
                        field_type: 'DecimalPicogramsPerMilliliter',
                        validation_name: 'NotEmpty',
                        detail_group: 'TaskDetail',
                        export_name: 'IFN',
                    },
                    {
                        field: 'il_1',
                        field_label_en: 'IL-1β',
                        field_type: 'DecimalPicogramsPerMilliliter',
                        validation_name: 'NotEmpty',
                        detail_group: 'TaskDetail',
                        export_name: 'IL_1',
                    },
                    {
                        field: 'il_4',
                        field_label_en: 'IL-4',
                        field_type: 'DecimalPicogramsPerMilliliter',
                        validation_name: 'NotEmpty',
                        detail_group: 'TaskDetail',
                        export_name: 'IL_4',
                    },
                    {
                        field: 'il_5',
                        field_label_en: 'IL-5',
                        field_type: 'DecimalPicogramsPerMilliliter',
                        validation_name: 'NotEmpty',
                        detail_group: 'TaskDetail',
                        export_name: 'IL_5',
                    },
                    {
                        field: 'il_12',
                        field_label_en: 'IL-12p70',
                        field_type: 'DecimalPicogramsPerMilliliter',
                        validation_name: 'NotEmpty',
                        detail_group: 'TaskDetail',
                        export_name: 'IL_12',
                    },
                ],
            },
        ],
        TaskSupplementAdministration: [
            {
                tableName: 'Table11016172122232526',
                data: [
                    {
                        field: 'study_day',
                        field_label_en: 'Study Day',
                        field_type: 'Number',
                        export_name: 'STUDY_DAY',
                    },
                    {
                        field: 'administration_dt',
                        field_label_en: 'Date of administration',
                        field_type: 'Date',
                        validation_name: 'NotEmpty',
                        validation_name_2: 'NotEmpty',
                        export_name: 'ADMINISTRATION_DT',
                    },
                    {
                        field: 'daily_supplement',
                        field_label_en: 'How many capsules were administered?',
                        field_type: 'Lookup',
                        validation_name: 'NotEmpty',
                        display_level: 'Detail',
                        validation_name_2: 'NotEmpty',
                        options: 'supplement_options',
                        min_count: '1',
                        max_count: '1',
                        export_name: 'DAILY_SUPPLEMENT',
                    },
                    {
                        field: 'is_mixed',
                        field_label_en: 'Was supplement mixed with food?',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        validation_name_2: 'NotEmpty',
                        export_name: 'IS_MIXED',
                    },
                ],
            },
        ],
        TaskRtiSymptoms: [
            {
                tableName: 'Table110161819',
                data: [
                    {
                        field: 'study_day',
                        field_label_en: 'Study Day',
                        field_type: 'Number',
                        export_name: 'STUDY_DAY',
                    },
                    {
                        field: 'rti_dt',
                        field_label_en: 'Date of RTI Symptom Assessment',
                        field_type: 'Date',
                        validation_name: 'NotEmpty',
                        export_name: 'RTI_DT',
                    },
                    {
                        field: 'cough_severity',
                        field_label_en: 'Cough Severity',
                        field_type: 'Lookup',
                        validation_name: 'NotEmpty',
                        options: 'RTI_Severity',
                        min_count: '1',
                        max_count: '1',
                        export_name: 'COUGH_SEVERITY',
                    },
                    {
                        field: 'nasal_congestion_severity',
                        field_label_en: 'Nasal Congestion Severity',
                        field_type: 'Lookup',
                        validation_name: 'NotEmpty',
                        options: 'RTI_Severity',
                        min_count: '1',
                        max_count: '1',
                        export_name: 'NASAL_CONGESTION_SEVERITY',
                    },
                    {
                        field: 'sneezing_severity',
                        field_label_en: 'Sneezing Severity',
                        field_type: 'Lookup',
                        validation_name: 'NotEmpty',
                        options: 'RTI_Severity',
                        min_count: '1',
                        max_count: '1',
                        export_name: 'SNEEZING_SEVERITY',
                    },
                    {
                        field: 'sore_throat_severity',
                        field_label_en: 'Sore Throat Severity',
                        field_type: 'Lookup',
                        validation_name: 'NotEmpty',
                        options: 'RTI_Severity',
                        min_count: '1',
                        max_count: '1',
                        export_name: 'SORE_THROAT_SEVERITY',
                    },
                    {
                        field: 'sinus_congestion_severity',
                        field_label_en: 'Sinus Congestion Severity',
                        field_type: 'Lookup',
                        validation_name: 'NotEmpty',
                        options: 'RTI_Severity',
                        min_count: '1',
                        max_count: '1',
                        export_name: 'SINUS_CONGESTION_SEVERITY',
                    },
                    {
                        field: 'anosmia_severity',
                        field_label_en: 'Anosmia Severity',
                        field_type: 'Lookup',
                        validation_name: 'NotEmpty',
                        options: 'RTI_Severity',
                        min_count: '1',
                        max_count: '1',
                        export_name: 'ANOSMIA_SEVERITY',
                    },
                    {
                        field: 'ageusia_severity',
                        field_label_en: 'Ageusia Severity',
                        field_type: 'Lookup',
                        validation_name: 'NotEmpty',
                        options: 'RTI_Severity',
                        min_count: '1',
                        max_count: '1',
                        export_name: 'AGEUSIA_SEVERITY',
                    },
                    {
                        field: 'respiratory_distress_severity',
                        field_label_en: 'Tachypnea, Respiratory Distress Severity',
                        field_type: 'Lookup',
                        validation_name: 'NotEmpty',
                        options: 'RTI_Severity',
                        export_name: 'RESPIRATORY_DISTRESS_SEVERITY',
                    },
                    {
                        field: 'headache_severity',
                        field_label_en: 'Headache Severity',
                        field_type: 'Lookup',
                        validation_name: 'NotEmpty',
                        options: 'RTI_Severity',
                        min_count: '1',
                        max_count: '1',
                        export_name: 'HEADACHE_SEVERITY',
                    },
                    {
                        field: 'fever_severity',
                        field_label_en: 'Fever Severity',
                        field_type: 'Lookup',
                        validation_name: 'NotEmpty',
                        options: 'RTI_Severity',
                        min_count: '1',
                        max_count: '1',
                        export_name: 'FEVER_SEVERITY',
                    },
                    {
                        field: 'fatigue_severity',
                        field_label_en: 'Fatigue Severity',
                        field_type: 'Lookup',
                        validation_name: 'NotEmpty',
                        options: 'RTI_Severity',
                        min_count: '1',
                        max_count: '1',
                        export_name: 'FATIGUE_SEVERITY',
                    },
                    {
                        field: 'unwell_severity',
                        field_label_en: 'Feeling Unwell Severity',
                        field_type: 'Lookup',
                        validation_name: 'NotEmpty',
                        options: 'RTI_Severity',
                        min_count: '1',
                        max_count: '1',
                        export_name: 'UNWELL_SEVERITY',
                    },
                    {
                        field: 'aches_severity',
                        field_label_en: 'Aches Severity',
                        field_type: 'Lookup',
                        validation_name: 'NotEmpty',
                        options: 'RTI_Severity',
                        min_count: '1',
                        max_count: '1',
                        export_name: 'ACHES_SEVERITY',
                    },
                    {
                        field: 'confusion_severity',
                        field_label_en: 'Confusion Severity',
                        field_type: 'Lookup',
                        validation_name: 'NotEmpty',
                        options: 'RTI_Severity',
                        min_count: '1',
                        max_count: '1',
                        export_name: 'CONFUSION_SEVERITY',
                    },
                    {
                        field: 'last_rti_dt',
                        field_label_en: 'Calculated last RTI Date',
                        field_type: 'Date',
                        validation_name: 'Calculation',
                        export_name: 'LAST_RTI_DT',
                    },
                    {
                        field: 'key_symptoms_today',
                        field_label_en: 'Calculated Key symptoms for today',
                        field_type: 'Number',
                        validation_name: 'Calculation',
                        export_name: 'KEY_SYMPTOMS_TODAY',
                    },
                    {
                        field: 'key_symptoms_yesterday',
                        field_label_en: 'Calculated Key symptoms yesterday',
                        field_type: 'Number',
                        validation_name: 'Calculation',
                        export_name: 'KEY_SYMPTOMS_YESTERDAY',
                    },
                    {
                        field: 'other_symptoms_today',
                        field_label_en: 'Calculated Other sympots for today',
                        field_type: 'Number',
                        validation_name: 'Calculation',
                        export_name: 'OTHER_SYMPTOMS_TODAY',
                    },
                    {
                        field: 'other_symptoms_yesterday',
                        field_label_en: 'Calculated Other sympots for yesterday',
                        field_type: 'Number',
                        validation_name: 'Calculation',
                        export_name: 'OTHER_SYMPTOMS_YESTERDAY',
                    },
                ],
            },
        ],
        TaskNasopharyngealSwab: [
            {
                tableName: 'Table11016171634',
                data: [
                    {
                        field: 'no_reason',
                        field_label_en: 'Reason for not collecting',
                        field_type: 'Text',
                        validation_name: 'NotEmpty',
                        export_name: 'NO_REASON',
                    },
                    {
                        field: 'was_swab_collected',
                        field_label_en: 'Was swab collected',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        export_name: 'WAS_SWAB_COLLECTED',
                    },
                ],
            },
        ],
        TaskNasopharyngeal: [
            {
                tableName: 'Table1101617163442',
                data: [
                    {
                        field: 'swab_collection_dt',
                        field_label_en: 'Date Nasopharyngeal Swab Collected',
                        field_type: 'Date',
                        validation_name: 'NotEmpty',
                        export_name: 'SWAB_COLLECTION_DT',
                    },
                    {
                        field: 'swab_collection_time',
                        field_label_en: 'Time of Collection',
                        field_type: 'Time',
                        validation_name: 'NotEmpty',
                        export_name: 'SWAB_COLLECTION_TIME',
                    },
                    {
                        field: 'has_bordetella_pertussis',
                        field_label_en: 'Bordetella pertussis',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        export_name: 'HAS_BORDETELLA_PERTUSSIS',
                    },
                    {
                        field: 'has_chlamydia_pneumoniae',
                        field_label_en: 'Chlamydia pneumoniae',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        export_name: 'HAS_CHLAMYDIA_PNEUMONIAE',
                    },
                    {
                        field: 'has_bordetella_parapertussis',
                        field_label_en: 'Bordetella parapertussis',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        export_name: 'HAS_BORDETELLA_PARAPERTUSSIS',
                    },
                    {
                        field: 'has_mycoplasma_pneumoniae',
                        field_label_en: 'Mycoplasma pneumoniae',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        export_name: 'HAS_MYCOPLASMA_PNEUMONIAE',
                    },
                    {
                        field: 'has_adenovirus',
                        field_label_en: 'Adenovirus',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        export_name: 'HAS_ADENOVIRUS',
                    },
                    {
                        field: 'has_coronavirus_hku1',
                        field_label_en: 'Coronavirus HKU1',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        export_name: 'HAS_CORONAVIRUS_HKU1',
                    },
                    {
                        field: 'has_coronavirus_nl63',
                        field_label_en: 'Coronavirus NL63',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        export_name: 'HAS_CORONAVIRUS_NL63',
                    },
                    {
                        field: 'has_coronavirus_229e',
                        field_label_en: 'Coronavirus 229E',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        export_name: 'HAS_CORONAVIRUS_229E',
                    },
                    {
                        field: 'has_coronavirus_oc43',
                        field_label_en: 'Coronavirus OC43',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        export_name: 'HAS_CORONAVIRUS_OC43',
                    },
                    {
                        field: 'has_sars_cov_2',
                        field_label_en: 'SARS-CoV-2 (Covid-19)',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        export_name: 'HAS_SARS_COV_2',
                    },
                    {
                        field: 'has_human_metapneumovirus',
                        field_label_en: 'Human Metapneumovirus',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        export_name: 'HAS_HUMAN_METAPNEUMOVIRUS',
                    },
                    {
                        field: 'has_respiratory_syncytial_virus',
                        field_label_en: 'Respiratory Syncytial Virus',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        export_name: 'HAS_RESPIRATORY_SYNCYTIAL_VIRUS',
                    },
                    {
                        field: 'has_influenza_a',
                        field_label_en: 'Influenza A',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        export_name: 'HAS_INFLUENZA_A',
                    },
                    {
                        field: 'has_influenza_b',
                        field_label_en: 'Influenza B',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        export_name: 'HAS_INFLUENZA_B',
                    },
                    {
                        field: 'has_parainfluenza_virus_1',
                        field_label_en: 'Parainfluenza Virus 1',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        export_name: 'HAS_PARAINFLUENZA_VIRUS_1',
                    },
                    {
                        field: 'has_parainfluenza_virus_2',
                        field_label_en: 'Parainfluenza Virus 2',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        export_name: 'HAS_PARAINFLUENZA_VIRUS_2',
                    },
                    {
                        field: 'has_parainfluenza_virus_3',
                        field_label_en: 'Parainfluenza Virus 3',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        export_name: 'HAS_PARAINFLUENZA_VIRUS_3',
                    },
                    {
                        field: 'has_parainfluenza_virus_4',
                        field_label_en: 'Parainfluenza Virus 4',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        export_name: 'HAS_PARAINFLUENZA_VIRUS_4',
                    },
                    {
                        field: 'has_human_rhinovirus',
                        field_label_en: 'Human Rhinovirus / Enterovirus',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        export_name: 'HAS_HUMAN_RHINOVIRUS',
                    },
                ],
            },
        ],
        TaskSupplementalVaccination: [
            {
                tableName: 'Table11016177',
                data: [
                    {
                        field: 'date_administered',
                        field_label_en: 'Date Administered',
                        field_type: 'Date',
                        validation_name: 'NotEmpty',
                        detail_group: 'Task Detail',
                        export_name: 'DATE_ADMINISTERED',
                    },
                    {
                        field: 'vaccination_type',
                        field_label_en: 'Vaccination Type',
                        field_type: 'Lookup',
                        validation_name: 'NotEmpty',
                        detail_group: 'Task Detail',
                        options: 'Vaccination_type',
                        export_name: 'VACCINATION_TYPE',
                    },
                ],
            },
        ],
        TaskFinalEvaluation: [
            {
                tableName: 'Table1101617163416',
                data: [
                    {
                        field: 'is_randomized',
                        field_label_en: 'Was the Subject Randomized?',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        detail_group: 'Task Detail',
                        export_name: 'IS_RANDOMIZED',
                    },
                    {
                        field: 'non_randomization_reason',
                        field_label_en: 'Reason if Not Randomized',
                        field_type: 'Lookup',
                        detail_group: 'Task Detail',
                        options: 'non_randomization_reason',
                        export_name: 'NON_RANDOMIZATION_REASON',
                    },
                    {
                        field: 'non_randomization_notes',
                        field_label_en: 'Non Randomization Notes',
                        field_type: 'Text',
                        detail_group: 'Task Detail',
                        export_name: 'NON_RANDOMIZATION_NOTES',
                    },
                    {
                        field: 'has_discontinued',
                        field_label_en: 'Did the Subject Discontinue From the Study?',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        detail_group: 'Task Detail',
                        export_name: 'HAS_DISCONTINUED',
                    },
                    {
                        field: 'discontinue_dt',
                        field_label_en: 'Date Discontinued',
                        field_type: 'Date',
                        detail_group: 'Task Detail',
                        export_name: 'DISCONTINUE_DT',
                    },
                    {
                        field: 'supplement_discontinued',
                        field_label_en:
                            'Based on the Investigator’s Opinion, Was the Supplement Discontinued Due to Intolerance?',
                        field_type: 'Boolean',
                        detail_group: 'Task Detail',
                        export_name: 'SUPPLEMENT_DISCONTINUED',
                    },
                    {
                        field: 'reason_for_discontinuation',
                        field_label_en:
                            'Based on the Investigator’s Opinion, What is the Primary Reason for Discontinuation?',
                        field_type: 'Lookup',
                        detail_group: 'Task Detail',
                        options: 'discontinuation_reason',
                    },
                    {
                        field: 'discontinuation_notes',
                        field_label_en: 'Discontinuation Notes',
                        field_type: 'Text',
                        detail_group: 'Task Detail',
                    },
                ],
            },
        ],
        AdverseEvents: [
            {
                tableName: 'Table110161721222325263233',
                data: [
                    {
                        field: 'id',
                        field_type: 'ID',
                        export_name: 'ID',
                    },
                    {
                        field: 'participant_id',
                        field_label_en: 'Participant ID',
                        field_type: 'Foreign Key',
                        related_table: 'Participant',
                        export_name: 'PARTICIPANT_ID',
                    },
                    {
                        field: 'reported_dt',
                        field_label_en: 'Reported On',
                        field_type: 'DateTime',
                        validation_name: 'NotEmpty',
                        default_value: '{{now()}}',
                        export_name: 'REPORTED_DT',
                    },
                    {
                        field: 'reported_by',
                        field_label_en: 'Reported By',
                        field_type: 'Foreign Key',
                        related_table: 'PortalUser',
                        export_name: 'REPORTED_BY',
                    },
                    {
                        field: 'created_dt',
                        field_label_en: 'Created On',
                        field_type: 'DateTime',
                        validation_name: 'NotEmpty',
                        default_value: '{{now()}}',
                        export_name: 'CREATED_DT',
                    },
                    {
                        field: 'created_by',
                        field_label_en: 'Created By',
                        field_type: 'Foreign Key',
                        related_table: 'PortalUser',
                        export_name: 'CREATED_BY',
                    },
                    {
                        field: 'adverse_event_name',
                        field_label_en: 'Adverse Event Name',
                        field_type: 'Text',
                        validation_name: 'NotEmpty',
                        export_name: 'ADVERSE_EVENT_NAME',
                    },
                    {
                        field: 'start_dt',
                        field_label_en: 'Started On',
                        field_type: 'Date',
                        validation_name: 'NotEmpty',
                        export_name: 'START_DT',
                    },
                    {
                        field: 'stop_other_status',
                        field_label_en: 'Stop or Other Status',
                        field_type: 'Lookup',
                        validation_name: 'NotEmpty',
                        options: 'stop_status',
                        export_name: 'STOP_OTHER_STATUS',
                    },
                    {
                        field: 'stop_dt',
                        field_label_en: 'Stop Date or Other Status Date',
                        field_type: 'Date',
                        validation_name: 'NotEmpty',
                        export_name: 'STOP_DT',
                    },
                    {
                        field: 'severity',
                        field_label_en: 'Severity',
                        field_type: 'Lookup',
                        validation_name: 'NotEmpty',
                        options: 'Severity',
                        export_name: 'SEVERITY',
                    },
                    {
                        field: 'action_taken',
                        field_label_en: 'Action Taken',
                        field_type: 'Lookup',
                        validation_name: 'NotEmpty',
                        options: 'AE_Action',
                        export_name: 'ACTION_TAKEN',
                    },
                    {
                        field: 'action_taken_specify',
                        field_label_en: 'Other (specify)',
                        field_type: 'Text',
                        validation_name: 'NotEmpty',
                        export_name: 'ACTION_TAKEN_SPECIFY',
                    },
                    {
                        field: 'relation',
                        field_label_en: 'Relation to Study Product',
                        field_type: 'Lookup',
                        options: 'Relationship',
                        export_name: 'RELATION',
                    },
                    {
                        field: 'has_given_conmed',
                        field_label_en: 'Conmed Given?',
                        field_type: 'Lookup',
                        validation_name: 'NotEmpty',
                        options: 'YesNoBoolean',
                        export_name: 'HAS_GIVEN_CONMED',
                    },
                    {
                        field: 'is_sae',
                        field_label_en: 'Reported as SAE?',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        export_name: 'IS_SAE',
                    },
                    {
                        field: 'is_stabilized',
                        field_label_en: 'Stabilized?',
                        field_type: 'Lookup',
                        options: 'OptionalBoolean',
                        export_name: 'IS_STABILIZED',
                    },
                    {
                        field: 'lock_status',
                        field_label_en: 'Lock Status',
                        field_type: 'Boolean',
                        export_name: 'LOCK_STATUS',
                    },
                    {
                        field: 'lock_by',
                        field_label_en: 'Locked by',
                        field_type: 'Lookup',
                        export_name: 'LOCK_BY',
                    },
                    {
                        field: 'lock_dt',
                        field_label_en: 'Lock date',
                        field_type: 'DateTime',
                        export_name: 'LOCK_DT',
                    },
                ],
            },
        ],
        TaskSeriousAdverseEvent: [
            {
                tableName: 'Table16789612',
                data: [
                    {
                        field: 'id',
                        field_type: 'ID',
                        detail_group: 'General',
                        export_name: 'ID',
                    },
                    {
                        field: 'participant_id',
                        field_label_en: 'Participant ID',
                        field_type: 'Foreign Key',
                        detail_group: 'General',
                        related_table: 'Participant',
                        export_name: 'PARTICIPANT_ID',
                    },
                    {
                        field: 'reported_dt',
                        field_label_en: 'Reported On',
                        field_type: 'DateTime',
                        validation_name: 'NotEmpty',
                        detail_group: 'Tracking',
                        default_value: '{{now()}}',
                        export_name: 'REPORTED_DT',
                    },
                    {
                        field: 'reported_by',
                        field_label_en: 'Reported By',
                        field_type: 'Foreign Key',
                        detail_group: 'General',
                        related_table: 'PortalUser',
                        export_name: 'REPORTED_BY',
                    },
                    {
                        field: 'created_dt',
                        field_label_en: 'Created On',
                        field_type: 'DateTime',
                        validation_name: 'NotEmpty',
                        detail_group: 'Tracking',
                        default_value: '{{now()}}',
                        export_name: 'CREATED_DT',
                    },
                    {
                        field: 'created_by',
                        field_label_en: 'Created By',
                        field_type: 'Foreign Key',
                        detail_group: 'General',
                        related_table: 'PortalUser',
                        export_name: 'CREATED_BY',
                    },
                    {
                        field: 'diagnosis_code',
                        field_label_en: 'SAE MeDRA LLT Code',
                        field_type: 'Number',
                        detail_group: 'General',
                        options: 'Link=/system/medra/{diagnosis_code}',
                        export_name: 'DIAGNOSIS_CODE',
                    },
                    {
                        field: 'diagnosis_name',
                        field_label_en: 'SAE Diagnostic Search Text',
                        field_type: 'Text',
                        validation_name: 'NotEmpty',
                        detail_group: 'SAE',
                        export_name: 'DIAGNOSIS_NAME',
                    },
                    {
                        field: 'diagnosis_description',
                        field_label_en: 'SAE Diagnostic Description',
                        field_type: 'Text',
                        validation_name: 'NotEmpty',
                        detail_group: 'SAE',
                        export_name: 'DIAGNOSIS_DESCRIPTION',
                    },
                    {
                        field: 'report_type',
                        field_label_en: 'Report Type',
                        field_type: 'Lookup',
                        validation_name: 'NotEmpty',
                        detail_group: 'SAE',
                        options: 'SAE_ReportType',
                        export_name: 'REPORT_TYPE',
                    },
                    {
                        field: 'seriousness',
                        field_label_en: 'Seriousness',
                        field_type: 'Lookup',
                        validation_name: 'NotEmpty',
                        detail_group: 'SAE',
                        options: 'Seriousness',
                        min_count: '1',
                        max_count: '8',
                        export_name: 'SERIOUSNESS',
                    },
                    {
                        field: 'chronological_description',
                        field_label_en: 'Chronological Description',
                        field_type: 'Text',
                        validation_name: 'NotEmpty',
                        detail_group: 'SAE',
                        export_name: 'CHRONOLOGICAL_DESCRIPTION',
                    },
                    {
                        field: 'diagnosis_syndrome',
                        field_label_en: 'Diagnosis or Syndrome',
                        field_type: 'Text',
                        validation_name: 'NotEmpty',
                        detail_group: 'SAE',
                        export_name: 'DIAGNOSIS_SYNDROME',
                    },
                    {
                        field: 'relevant_medical_history',
                        field_label_en: 'Relevant Medical History',
                        field_type: 'Text',
                        validation_name: 'NotEmpty',
                        detail_group: 'SAE',
                        export_name: 'RELEVANT_MEDICAL_HISTORY',
                    },
                    {
                        field: 'start_dt',
                        field_label_en: 'Start Date of Event',
                        field_type: 'Date',
                        validation_name: 'NotEmpty',
                        detail_group: 'SAE',
                        export_name: 'START_DT',
                    },
                    {
                        field: 'is_ongoing',
                        field_label_en: 'Is This an Ongoing Situation?',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        detail_group: 'SAE',
                        export_name: 'IS_ONGOING',
                    },
                    {
                        field: 'end_dt',
                        field_label_en: 'End Date of Event',
                        field_type: 'Date',
                        validation_name: 'NotEmpty',
                        detail_group: 'SAE',
                        export_name: 'END_DT',
                    },
                    {
                        field: 'severity',
                        field_label_en: 'Severity',
                        field_type: 'Lookup',
                        validation_name: 'NotEmpty',
                        detail_group: 'SAE',
                        options: 'Severity',
                        export_name: 'SEVERITY',
                    },
                    {
                        field: 'has_improved',
                        field_label_en:
                            'Improvement of Event After Stopping Product Administration?',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        detail_group: 'SAE',
                        export_name: 'HAS_IMPROVED',
                    },
                    {
                        field: 'product_readministration',
                        field_label_en: 'Was Product Readministered?',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        detail_group: 'SAE',
                        export_name: 'PRODUCT_READMINISTRATION',
                    },
                    {
                        field: 'has_reappeared',
                        field_label_en: 'Event Reappear After the Readministration?',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        detail_group: 'SAE',
                        export_name: 'HAS_REAPPEARED',
                    },
                    {
                        field: 'is_associated',
                        field_label_en: 'Event Association With Study Product',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        detail_group: 'SAE',
                        export_name: 'IS_ASSOCIATED',
                    },
                    {
                        field: 'outcome',
                        field_label_en: 'Outcome',
                        field_type: 'Lookup',
                        validation_name: 'NotEmpty',
                        detail_group: 'SAE',
                        options: 'Outcome',
                        export_name: 'OUTCOME',
                    },
                    {
                        field: 'outcome_notes',
                        field_label_en: 'Outcome Notes',
                        field_type: 'Text',
                        validation_name: 'NotEmpty',
                        detail_group: 'SAE',
                        export_name: 'OUTCOME_NOTES',
                    },
                    {
                        field: 'medreview_code',
                        field_label_en: 'Post-trial Medical Review Medra Coding',
                        field_type: 'Number',
                        detail_group: 'Medical Review',
                        export_name: 'MEDREVIEW_CODE',
                    },
                    {
                        field: 'medreview_name',
                        field_label_en: 'Post-trial Medical Reviewer Name',
                        field_type: 'Text',
                        detail_group: 'Medical Review',
                        export_name: 'MEDREVIEW_NAME',
                    },
                    {
                        field: 'medreview_notes',
                        field_label_en: 'Post-trial Medical Reviewer Notes',
                        field_type: 'Text',
                        detail_group: 'Medical Review',
                        export_name: 'MEDREVIEW_NOTES',
                    },
                ],
            },
        ],
        Notes: [
            {
                tableName: 'Table16789614',
                data: [
                    {
                        field: 'id',
                        field_type: 'ID',
                        export_name: 'ID',
                    },
                    {
                        field: 'reported_dt',
                        field_label_en: 'Reported On',
                        field_type: 'DateTime',
                        validation_name: 'NotEmpty',
                        related_table: 'Tracking',
                        default_value: '{{now()}}',
                        options: 'MM/DD/YYYY',
                        export_name: 'REPORTED_DT',
                    },
                    {
                        field: 'reported_by',
                        field_label_en: 'Reported By',
                        field_type: 'Foreign Key',
                        related_table: 'Tracking',
                        default_value: 'PortalUser',
                        export_name: 'REPORTED_BY',
                    },
                    {
                        field: 'created_dt',
                        field_label_en: 'Created On',
                        field_type: 'DateTime',
                        validation_name: 'NotEmpty',
                        related_table: 'Tracking',
                        default_value: '{{now()}}',
                        options: 'MM/DD/YYYY',
                        export_name: 'CREATED_DT',
                    },
                    {
                        field: 'created_by',
                        field_label_en: 'Created By',
                        field_type: 'Foreign Key',
                        related_table: 'Tracking',
                        default_value: 'PortalUser',
                        export_name: 'CREATED_BY',
                    },
                    {
                        field: 'participant_id',
                        field_label_en: 'Participant ID',
                        field_type: 'Foreign Key',
                        related_table: 'Participant',
                        export_name: 'PARTICIPANT_ID',
                    },
                    {
                        field: 'note_type',
                        field_label_en: 'Type',
                        field_type: 'Lookup',
                        validation_name: 'NotEmpty',
                        options: 'note_type',
                        min_count: '1',
                        max_count: '1',
                        export_name: 'NOTE_TYPE',
                    },
                    {
                        field: 'note_desc',
                        field_label_en: 'Note Description',
                        field_type: 'Text',
                        validation_name: 'NotEmpty',
                        export_name: 'NOTE_DESC',
                    },
                    {
                        field: 'reply_dt',
                        field_label_en: 'Reply Date',
                        field_type: 'DateTime',
                        export_name: 'REPLY_DT',
                    },
                    {
                        field: 'reply_by',
                        field_label_en: 'Reply By',
                        field_type: 'Text',
                        export_name: 'REPLY_BY',
                    },
                    {
                        field: 'reply_text',
                        field_label_en: 'Reply',
                        field_type: 'Text',
                        export_name: 'REPLY_TEXT',
                    },
                    {
                        field: 'is_read',
                        field_label_en: 'Has been read',
                        field_type: 'Boolean',
                        export_name: 'IS_READ',
                    },
                    {
                        field: 'is_reply_read',
                        field_label_en: 'Has Reply been read',
                        field_type: 'Boolean',
                        export_name: 'IS_REPLY_READ',
                    },
                    {
                        field: 'has_reply',
                        field_label_en: 'Has Reply',
                        field_type: 'Boolean',
                        export_name: 'HAS_REPLY',
                    },
                    {
                        field: 'lock_status',
                        field_label_en: 'Lock Status',
                        field_type: 'Boolean',
                        export_name: 'LOCK_STATUS',
                    },
                    {
                        field: 'lock_by',
                        field_label_en: 'Locked by',
                        field_type: 'Lookup',
                        export_name: 'LOCK_BY',
                    },
                    {
                        field: 'lock_dt',
                        field_label_en: 'Lock date',
                        field_type: 'DateTime',
                        export_name: 'LOCK_DT',
                    },
                ],
            },
        ],
        NotesDocument: [
            {
                tableName: 'Table11015',
                data: [
                    {
                        field: 'id',
                        field_type: 'ID',
                        detail_group: 'General',
                        blinded: 'No',
                        pii: 'No',
                        export_name: 'ID',
                    },
                    {
                        field: 'document_id',
                        field_label_en: 'Document ID',
                        field_type: 'Foreign Key',
                        detail_group: 'General',
                        related_table: 'Documents',
                        export_name: 'DOCUMENT_ID',
                    },
                    {
                        field: 'note_id',
                        field_label_en: 'Note ID',
                        field_type: 'Foreign Key',
                        validation_name: 'NotEmpty',
                        detail_group: 'Dates',
                        related_table: 'Notes',
                        export_name: 'NOTE_ID',
                    },
                    {
                        field: 'save_file',
                        field_label_en: 'Location Saved on File Server',
                        field_type: 'Text',
                        export_name: 'SAVE_FILE',
                    },
                ],
            },
        ],
        StartRandomize: [
            {
                tableName: 'Table11016182832',
                data: [
                    {
                        field: 'randomize_dt',
                        field_label_en: 'Randomize Date',
                        field_type: 'Date',
                        validation_name: 'NotEmpty',
                        detail_group: 'Task Detail',
                        export_name: 'RANDOMIZE_DT',
                    },
                    {
                        field: 'confirm_rti',
                        field_label_en: 'RTI for the Last 7 Days',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        display_level: 'Task Detail',
                        detail_group: 'Task Detail',
                    },
                ],
            },
        ],
        WithdrawParticipant: [
            {
                tableName: 'Table110162938',
                data: [
                    {
                        field: 'id',
                        field_type: 'ID',
                        export_name: 'ID',
                    },
                    {
                        field: 'created_dt',
                        field_label_en: 'Created On',
                        field_type: 'DateTime',
                        validation_name: 'NotEmpty',
                        detail_group: 'Tracking',
                        related_table: '{{now()}}',
                        export_name: 'CREATED_DT',
                    },
                    {
                        field: 'created_by',
                        field_label_en: 'Created By',
                        field_type: 'Foreign Key',
                        detail_group: 'Tracking',
                        related_table: 'PortalUser',
                        export_name: 'CREATED_BY',
                    },
                    {
                        field: 'participant_id',
                        field_label_en: 'Participant ID',
                        field_type: 'Foreign Key',
                        detail_group: 'Participant',
                        export_name: 'PARTICIPANT_ID',
                    },
                    {
                        field: 'withdraw_reason',
                        field_label_en: 'Withdraw Reason',
                        field_type: 'Lookup',
                        validation_name: 'NotEmpty',
                        detail_group: 'General',
                        options: 'withdraw_reasons',
                        min_count: '1',
                        max_count: '1',
                        export_name: 'WITHDRAW_REASON',
                    },
                    {
                        field: 'other_reason',
                        field_label_en: 'Other (reason)',
                        field_type: 'Text',
                        validation_name: 'NotEmpty',
                        detail_group: 'General',
                        export_name: 'OTHER_REASON',
                    },
                    {
                        field: 'due_to_intolerance',
                        field_label_en: 'Withdraw Due to Intolerance',
                        field_type: 'Boolean',
                        validation_name: 'NotEmpty',
                        detail_group: 'General',
                        export_name: 'DUE_TO_INTOLERANCE',
                    },
                    {
                        field: 'withdraw_dt',
                        field_label_en: 'Withdraw Date',
                        field_type: 'Date',
                        validation_name: 'NotEmpty',
                        detail_group: 'General',
                        export_name: 'WITHDRAW_DT',
                    },
                ],
            },
        ],
    },
};

export const TaskBaselineCbc = {
    _id: '6041ce69dd0dbab3fae18f89',
    id: 'klvwvecryoy7',
    blood_collection_dt: '2021-03-04',
    blood_collection_time: '23:53',
    wbc: 12,
    rbc: 12,
    hgb: 12,
    hct: 1,
    mcv: 1,
    mch: 1,
    mchc: 1,
    rdw: 1,
    platelets: 1,
    neutrophils_percent: 11,
    lymphocytes_percent: 1,
    monocytes_percent: 1,
    eosinophils_percent: 1,
    basophils_percent: 1,
    ig_percent: 1,
    nrbc_percent: 1,
    neutrophils: 1,
    lymphocytes: 1,
    monocytes: 1,
    eosinophils: 1,
    basophils: 1,
    ig: 1,
    nrbc: 1,
    participant_id: '775-818-1079',
    created_dt: '2021-03-05T06:22:55.083Z',
    created_by: 'viral',
    task_id: 'klvw4238todl',
    task_title: 'Basic CBC Results for Day 45',
    reported_dt: '2021-03-05T06:23:37.076Z',
    reported_by: 'viral',
    __v: 0,
};

export default TestData;
